import React, { useEffect, useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Arrow from "../svg/Arrow";
import Plus1 from "../svg/Plus1";
import EditTool from "../svg/EditTool";
import { DizeeInput2 } from "./DizeeComponent/DixeeInput2";
import styled from "styled-components";
import Plus from "../svg/Plus";
import { useDispatch } from "react-redux";
import { processQuestionForDizee } from "../pages/Manager/api/openaiService";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { closeChat, openChat, setChatHistory, clearChatHistory, clearChatHistoryOnly } from "../store/chat/chatSlice";
import { promptsApi } from "../utils/promptsApi";
import { setUserArticle } from "../store/user/userSlice";
import { update_user_article_thunk } from "../store/user/userThunk";

import { useCallback } from "react";
import { debounce } from "lodash";
import { ReactComponent as PagesIcon } from "../assets/images/components/Pages-Icon.svg";
import { imageDataFormatter } from "../utils/imageDataFormatter";

import { ReactComponent as BookingsIcon } from "../assets/images/components/Bookings-Icon.svg";
import { ReactComponent as CatalogIcon } from "../assets/images/components/Catalog-Icon.svg";
import { ReactComponent as RetouchIcon } from "../assets/images/components/Retouch-Icon.svg";
import { ReactComponent as ColorIcon } from "../assets/images/components/Color-Icon.svg";
import { presetPromptsApi } from "../utils/presetPromptsApi";
import PermissionWrapper from "./Permissions/PermissionWrapper";
import { hasAIAccess } from "../utils/permissions";
import { shouldShowDailyDigest, shouldShowDailyDigestSync, markDigestAsShown } from "../utils/dailyDigest";
import { shouldShowAccountSetup, markSetupAsCompleted, generateSetupPrompt, parseAppLinks, getUserState, generateOnboardingAgentPrompt } from "../utils/accountSetup";
import { NavigationInterceptor, cleanNavigationCommands } from "./Agent/NavigationInterceptor";
import { TourOptions } from "./InteractiveTour/TourOptions";
import { TourPresetQuestions } from "./InteractiveTour/TourPresetQuestions";
import ConfirmModal from "./Utils/ConfirmModal";
import { useConfirm } from "../hooks/useConfirm";
import { 
    getWelcomeMessage, 
    TOUR_CONTENT, 
    TOUR_SECTIONS, 
    getNextSection, 
    getMenuMessage,
    getCompletionMessage,
    QUICK_RESPONSES,
    QUESTION_ANSWERS,
    isTourActive,
    setTourActive,
    setCurrentTourSection,
    completeTour,
    clearTourMessages
} from "../utils/interactiveTour";

// Temporary icons for merch and custom - can be replaced with actual SVG files later
const MerchIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M2 3H10L9 9H3L2 3ZM2 3L1.5 1H0.5M4.5 11C4.77614 11 5 10.7761 5 10.5C5 10.2239 4.77614 10 4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11ZM8.5 11C8.77614 11 9 10.7761 9 10.5C9 10.2239 8.77614 10 8.5 10C8.22386 10 8 10.2239 8 10.5C8 10.7761 8.22386 11 8.5 11Z" stroke="currentColor" strokeWidth="0.8" fill="none"/>
  </svg>
);

const CustomIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M6 1L7.5 4.5H11L8.5 7L9.5 10.5L6 8.5L2.5 10.5L3.5 7L1 4.5H4.5L6 1Z" stroke="currentColor" strokeWidth="0.8" fill="none"/>
  </svg>
);



// Temporary ExpertsIcon component - can be replaced with actual SVG file later
const ExpertsIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M6 1C3.79 1 2 2.79 2 5C2 7.21 3.79 9 6 9C8.21 9 10 7.21 10 5C10 2.79 8.21 1 6 1ZM6 7.5C4.62 7.5 3.5 6.38 3.5 5C3.5 3.62 4.62 2.5 6 2.5C7.38 2.5 8.5 3.62 8.5 5C8.5 6.38 7.38 7.5 6 7.5ZM1 11V10.5C1 9.4 3.13 8.5 6 8.5C8.87 8.5 11 9.4 11 10.5V11H1Z" stroke="currentColor" strokeWidth="0.8" fill="none"/>
    </svg>
);

const AnalyticsIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M2 14V10M8 14V6M14 14V2M2 8L8 2L14 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const TeamIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M6 1C3.79 1 2 2.79 2 5C2 7.21 3.79 9 6 9C8.21 9 10 7.21 10 5C10 2.79 8.21 1 6 1ZM6 7.5C4.62 7.5 3.5 6.38 3.5 5C3.5 3.62 4.62 2.5 6 2.5C7.38 2.5 8.5 3.62 8.5 5C8.5 6.38 7.38 7.5 6 7.5ZM1 11V10.5C1 9.4 3.13 8.5 6 8.5C8.87 8.5 11 9.4 11 10.5V11H1Z" stroke="currentColor" strokeWidth="0.8" fill="none"/>
    </svg>
);



// Enhanced styled components for ChatGPT-like interface
const ChatOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 5;
  opacity: ${props => props.isVisible ? '1' : '0'};
  visibility: ${props => props.isVisible ? 'visible' : 'hidden'};
  transition: opacity 0.3s ease, visibility 0.3s ease;
  width: 100vw;
  height: 100vh;
  
  /* Hide chat overlay when sidebar is open */
  body.sidebar-open & {
    display: none;
  }
`;

const ChatContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #111111;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  width: 100%;
  max-width: 100vw;
  margin: 0;
  z-index: 5;
  transition: transform 0.3s ease;
  transform: ${props => props.isVisible ? 'translateY(0)' : 'translateY(100%)'};
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: visible !important;
  
  /* Hide chat container when sidebar is open */
  body.sidebar-open & {
    display: none;
  }
  
  @media (min-width: 768px) {
    max-width: 390px;
    margin: 0 auto;
  }
`;

const ChatHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px 10px;
  border-bottom: 1px solid #1A1A1A;
`;

const ChatTitle = styled.h3`
  color: white;
  font-size: 12px;
  font-weight: 400;
  margin: 0;
  line-height: 24px;
`;

const NewChatButton = styled.button`
  background: transparent;
  color: white;
  border: none;
  padding: 0;
  font-size: 12px;
  cursor: pointer;
  transition: color 0.2s;
  line-height: 24px;
  
  &:hover {
    color: rgba(255, 255, 255, 0.7);
  }
  
  &:active {
    transform: scale(0.98);
  }
`;

const MessagesArea = styled.div`
  flex: 1;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding: 15px 16px 15px 0;
  max-height: 400px;
  scrollbar-width: none;
  display: flex;
  flex-direction: column;
  -webkit-overflow-scrolling: touch;
  position: relative;
  
  &::-webkit-scrollbar {
    display: none;
  }
`;

const MessageBubble = styled.div`
  max-width: 85%;
  margin-bottom: 12px;
  margin-left: ${props => props.isUser ? 'auto' : '16px'};
  margin-right: ${props => props.isUser ? '16px' : 'auto'};
  display: flex;
  flex-direction: column;
  align-items: ${props => props.isUser ? 'flex-end' : 'flex-start'};
  align-self: ${props => props.isUser ? 'flex-end' : 'flex-start'};
`;

const BubbleContent = styled.div`
  background-color: ${props => props.isUser ? '#007AFF' : '#1A1A1A'};
  color: white;
  padding: 10px 15px;
  border-radius: 12px;
  border-bottom-right-radius: ${props => props.isUser ? '4px' : '12px'};
  border-bottom-left-radius: ${props => props.isUser ? '12px' : '4px'};
  font-size: 12px;
  line-height: 1.6;
  word-wrap: break-word;
  
  /* Enhanced formatting for AI responses */
  ${props => !props.isUser && `
    p {
      margin: 8px 0;
    }
    
    ul, ol {
      margin: 8px 0;
      padding-left: 16px;
    }
    
    li {
      margin: 4px 0;
    }
    
    strong {
      font-weight: 600;
      color: #ffffff;
    }
    
    em {
      font-style: italic;
      color: #ffffff;
    }
    
    /* Bullet point styling */
    ul li {
      list-style-type: disc;
    }
    
    /* Spacing for formatted content */
    div {
      margin: 4px 0;
    }
    
    div:first-child {
      margin-top: 0;
    }
    
    div:last-child {
      margin-bottom: 0;
    }
    
    /* Headers */
    h1, h2, h3, h4, h5, h6 {
      margin: 12px 0 8px 0;
      font-weight: 600;
    }
  `}
`;



const ThinkingIndicator = styled.div`
  color: #8E8E93;
  font-size: 12px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  
  &::after {
    content: '';
    animation: thinking 1.2s infinite;
    margin-left: 2px;
  }
  
  @keyframes thinking {
    0% { content: ''; }
    33% { content: '.'; }
    66% { content: '..'; }
    100% { content: '...'; }
  }
`;

const InputArea = styled.div`
  padding: 10px 16px 15px;
  border-top: 1px solid #1A1A1A;
`;


const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;

const ChatInputRow = styled.div`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: 0.5px solid #FF4500;
  border-radius: 20px;
  padding: 8px 12px;
  gap: 10px;
  flex: 1;
  box-shadow: 
    0 0 10px rgba(255, 69, 0, 0.3),
    0 0 20px rgba(255, 69, 0, 0.2),
    0 0 30px rgba(255, 69, 0, 0.1);
  transition: all 0.3s ease;
  
  &:focus-within {
    border: 0.5px solid #FF4500;
    box-shadow: 
      0 0 15px rgba(255, 69, 0, 0.4),
      0 0 25px rgba(255, 69, 0, 0.3),
      0 0 35px rgba(255, 69, 0, 0.15);
  }
`;

const ChatInput = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: white;
  font-size: 12px;
  line-height: 24px;
  padding: 0;
  
  &::placeholder {
    color: #8E8E93;
  }
`;

const ChatPlusBtn = styled.button`
  background: #4A4A4A;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  
  svg {
    filter: brightness(0);
  }
  
  &:hover {
    background: #5A5A5A;
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const SendButton = styled.button`
  background: ${props => props.hasText ? '#FF4500' : '#4A4A4A'};
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  
  svg {
    filter: brightness(0);
    transform: scale(0.8);
  }
  
  &:hover {
    background: ${props => props.hasText ? '#E63E00' : '#5A5A5A'};
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  &:disabled {
    background: #4A4A4A;
    cursor: not-allowed;
  }
`;

const MinimizedBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #111111;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  z-index: 5;
  width: 100%;
  max-width: 100vw;
  margin: 0;
  transition: all 0.3s ease;
  
  /* Hide footer when sidebar is open */
  body.sidebar-open & {
    display: none;
  }
  
  @media (min-width: 768px) {
    max-width: 390px;
    margin: 0 auto;
  }
`;

const MinimizedInputContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px 15px;
  gap: 10px;
  border-bottom: 1px solid #1A1A1A;
`;

const MinimizedInput = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: white;
  font-size: 12px;
  line-height: 24px;
  
  &::placeholder {
    color: #8E8E93;
  }
`;

const ToolsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: ${props => props.isExpanded ? '0' : '0 16px 20px'};
`;

// Removed old file preview styled components - now using inline styles for cleaner ChatGPT-like design

// Removed RemoveFileButton styled component - now using inline styles for cleaner design

const PresetPromptsContainer = styled.div`
  position: fixed;
  bottom: 100px;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 100vw;
  padding: 8px 16px 12px;
  max-height: ${props => props.isVisible ? '80px' : '0'};
  overflow: hidden;
  transition: max-height 0.3s ease;
  z-index: 5;
  
  /* Hide preset prompts when sidebar is open */
  body.sidebar-open & {
    display: none;
  }
  
  @media (min-width: 768px) {
    left: 50%;
    transform: translateX(-50%);
    max-width: 390px;
  }
`;

const PromptsScrollContainer = styled.div`
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding-bottom: 4px;
  scrollbar-width: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
`;

const PromptBox = styled.button`
  background: #1A1A1A;
  color: #E5E5E7;
  border: 1px solid #2A2A2A;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 11px;
  line-height: 1.3;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-width: fit-content;
  flex-shrink: 0;
  max-width: 250px;
  
  &:hover {
    background: #2A2A2A;
    border-color: #3A3A3A;
    transform: translateY(-1px);
  }
  
  &:active {
    transform: translateY(0) scale(0.98);
  }
`;

// Homepage-specific footer layout styled components
const HomepageFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #000000;
  z-index: 5;
  width: 100%;
  max-width: 100vw;
  margin: 0;
  
  /* Hide footer when sidebar is open */
  body.sidebar-open & {
    display: none;
  }
  
  @media (min-width: 768px) {
    max-width: 390px;
    margin: 0 auto;
  }
`;

const HomepagePresetsSection = styled.div`
  padding: 15px 16px 8px;
  overflow: visible;
`;

const HomepagePresetsRow = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  scrollbar-width: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
`;

const HomepagePresetItem = styled.button`
  background: transparent;
  color: rgba(255, 255, 255, 0.6);
  border: none;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 400;
  line-height: 1.3;
  white-space: nowrap;
  cursor: pointer;
  transition: opacity 0.2s;
  flex-shrink: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
  letter-spacing: -0.01em;
  
  &:hover {
    opacity: 0.8;
    color: rgba(255, 255, 255, 0.75);
  }
  
  &:active {
    transform: scale(0.98);
  }
`;

const HomepageInputSection = styled.div`
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
`;

const HomepageInputRow = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  animation: fadeInScale 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  
  @keyframes fadeInScale {
    0% {
      transform: scale(0.95);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

const HomepageInputField = styled.input`
  flex: 1;
  background: rgba(0, 0, 0, 0.4);
  border: 2px solid #FF2300;
  border-radius: 50px;
  padding: 12px 52px 12px 20px;
  color: rgba(255, 255, 255, 0.9);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-size: 15px;
  font-weight: 400;
  outline: none;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 0 20px rgba(255, 35, 0, 0.3), 0 0 40px rgba(255, 35, 0, 0.15);
  width: 100%;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
    transition: color 0.3s ease;
  }

  &:focus {
    border-color: #FF2300;
    box-shadow: 0 0 30px rgba(255, 35, 0, 0.4), 0 0 60px rgba(255, 35, 0, 0.2);
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ExpertsInputBar = styled.div`
  flex: 1;
  background: rgba(0, 0, 0, 0.4);
  border: 2px solid #FF2300;
  border-radius: 50px;
  padding: 12px 20px;
  color: rgba(255, 255, 255, 0.4);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-size: 15px;
  font-weight: 400;
  box-shadow: 0 0 20px rgba(255, 35, 0, 0.3), 0 0 40px rgba(255, 35, 0, 0.15);
  width: 100%;
  display: flex;
  align-items: center;
  animation: expandFromLeft 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  transform-origin: left center;
  
  @keyframes expandFromLeft {
    0% {
      transform: scaleX(0.6);
      opacity: 0;
    }
    100% {
      transform: scaleX(1);
      opacity: 1;
    }
  }
`;

const HomepageNavigationSection = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 16px 28px;
  overflow-x: auto;
  scrollbar-width: none;
  gap: 16px;
  
  &::-webkit-scrollbar {
    display: none;
  }
`;

const ExpandSimplifyButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.5);
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 400;
  backdrop-filter: blur(10px);
  transition: opacity 0.5s ease-out, visibility 0.5s ease-out, background 0.3s ease, color 0.3s ease, border-color 0.3s ease;
  
  &:hover {
    color: rgba(255, 255, 255, 1);
    background: rgba(0, 0, 0, 0.7);
    border-color: rgba(255, 255, 255, 0.2);
  }
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const HomepageButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 8px 16px 28px;
  justify-content: center;
  align-items: center;
`;

const HomepageNewChatButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.5);
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-size: 13px;
  font-weight: 400;
  backdrop-filter: blur(10px);
  opacity: ${props => props.disabled ? 0.4 : 1};
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};
  transition: background 0.3s ease, color 0.3s ease, border-color 0.3s ease, opacity 0.3s ease;
  
  &:hover {
    color: ${props => props.disabled ? 'rgba(255, 255, 255, 0.7)' : 'rgba(255, 255, 255, 1)'};
    background: ${props => props.disabled ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0.7)'};
    border-color: ${props => props.disabled ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.2)'};
  }
`;

const HomepageNavItem = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  transition: all 0.2s;
  flex-shrink: 0;
  white-space: nowrap;
  
  &:active {
    transform: scale(0.95);
  }
`;

const HomepageNavIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 12px;
    height: 12px;
    
    path {
      stroke: ${props => props.active ? '#FF4500' : '#8E8E93'};
    }
  }
`;

const HomepageNavText = styled.span`
  color: ${props => props.active ? '#FF2300' : 'rgba(255, 255, 255, 0.5)'};
  font-size: 13px;
  font-weight: ${props => props.active ? '500' : '400'};
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', sans-serif;
  letter-spacing: -0.01em;
  transition: color 0.2s ease;
`;

const HomepagePlusBtn = styled.button`
  background: #4A4A4A;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  animation: slideInFromLeft 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  
  @keyframes slideInFromLeft {
    0% {
      transform: translateX(-20px) scale(0.8);
      opacity: 0;
    }
    100% {
      transform: translateX(0) scale(1);
      opacity: 1;
    }
  }
  
  svg {
    filter: brightness(0);
  }
  
  &:hover {
    background: #5A5A5A;
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const HomepageSendBtn = styled.button`
  position: absolute;
  right: 4px;
  background: ${props => props.hasText ? '#FF2300' : 'rgba(255, 255, 255, 0.1)'};
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.hasText ? '#000000' : 'rgba(255, 255, 255, 0.3)'};
  font-size: 18px;
  cursor: ${props => props.hasText ? 'pointer' : 'not-allowed'};
  transition: all 0.3s ease;
  
  &:hover {
    ${props => props.hasText && `
      background: #ff3a1a;
      transform: scale(1.05);
    `}
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// Pages/Unreleased App specific footer layout styled components
const PagesFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #000000;
  z-index: 5;
  width: 100%;
  max-width: 100vw;
  margin: 0;
  
  /* Hide footer when sidebar is open */
  body.sidebar-open & {
    display: none;
  }
  
  @media (min-width: 768px) {
    max-width: 390px;
    margin: 0 auto;
  }
`;

const PagesPresetsSection = styled.div`
  padding: 15px 16px 8px;
`;

const PagesPresetsRow = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  scrollbar-width: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
`;

const PagesPresetItem = styled.button`
  background: transparent;
  color: white;
  border: none;
  padding: 8px 12px;
  font-size: 11px;
  line-height: 1.3;
  white-space: nowrap;
  cursor: pointer;
  transition: opacity 0.2s;
  flex-shrink: 0;
  
  &:hover {
    opacity: 0.7;
  }
  
  &:active {
    transform: scale(0.98);
  }
`;

const PagesInputSection = styled.div`
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const PagesPlusBtn = styled.button`
  background: #4A4A4A;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  
  svg {
    filter: brightness(0);
  }
  
  &:hover {
    background: #5A5A5A;
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const PagesInputRow = styled.div`
  display: flex;
  align-items: center;
  background-color: transparent;
  border: 0.5px solid #FF4500;
  border-radius: 20px;
  padding: 8px 12px;
  gap: 10px;
  flex: 1;
  box-shadow: 
    0 0 10px rgba(255, 69, 0, 0.3),
    0 0 20px rgba(255, 69, 0, 0.2),
    0 0 30px rgba(255, 69, 0, 0.1);
  transition: all 0.3s ease;
  
  &:focus-within {
    border: 0.5px solid #FF4500;
    box-shadow: 
      0 0 15px rgba(255, 69, 0, 0.4),
      0 0 25px rgba(255, 69, 0, 0.3),
      0 0 35px rgba(255, 69, 0, 0.15);
  }
`;

const PagesInputField = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: white;
  font-size: 12px;
  line-height: 24px;
  
  &::placeholder {
    color: #8E8E93;
  }
`;

const PagesSendBtn = styled.button`
  background: ${props => props.hasText ? '#FF4500' : '#4A4A4A'};
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  
  svg {
    filter: brightness(0);
    transform: scale(0.8);
  }
  
  &:hover {
    background: ${props => props.hasText ? '#E63E00' : '#5A5A5A'};
  }
  
  &:active {
    transform: scale(0.95);
  }
  
  &:disabled {
    background: #4A4A4A;
    cursor: not-allowed;
  }
`;

const PagesNavigationSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px 16px;
  position: relative;
`;

const PagesCenterPlusBtn = styled.button`
  background: white;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  
  &::before {
    content: '';
    position: absolute;
    width: 12px;
    height: 1px;
    background: black;
  }
  
  &::after {
    content: '';
    position: absolute;
    width: 1px;
    height: 12px;
    background: black;
  }
  
  &:hover {
    background: #E5E5E7;
  }
  
  &:active {
    transform: translateX(-50%) scale(0.95);
  }
`;

const PagesNavItem = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px 12px;
  transition: all 0.2s;
  
  &:active {
    transform: scale(0.95);
  }
`;

const PagesNavIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 16px;
    height: 7px;
    
    path, circle {
      stroke: white;
      fill: white;
    }
  }
`;

const PagesNavText = styled.span`
  color: white;
  font-size: 11px;
  font-weight: 400;
`;

// Slider styling components
const GrayscaleSlider = styled.input`
  width: 100px;
  height: 4px;
  border-radius: 2px;
  background: #ffffff !important;
  outline: none;
  opacity: 1;
  transition: opacity 0.2s;
  appearance: none;
  -webkit-appearance: none;
  border: none;

  &:hover {
    opacity: 0.8;
  }

  &::-webkit-slider-thumb {
    appearance: none;
    -webkit-appearance: none;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #ffffff;
    cursor: pointer;
    border: none;
  }

  &::-moz-range-thumb {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #ffffff;
    cursor: pointer;
    border: none;
  }

  &::-webkit-slider-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    background: #ffffff;
    border-radius: 2px;
    border: none;
  }

  &::-moz-range-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    background: #ffffff;
    border-radius: 2px;
    border: none;
  }
`;

const ColorSlider = styled.input`
  width: 80px;
  height: 4px;
  border-radius: 2px;
  outline: none;
  opacity: 0.7;
  transition: opacity 0.2s;
  appearance: none;
  -webkit-appearance: none;

  &:hover {
    opacity: 1;
  }

  &::-webkit-slider-thumb {
    appearance: none;
    -webkit-appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ffffff;
    cursor: pointer;
    border: none;
  }

  &::-moz-range-thumb {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ffffff;
    cursor: pointer;
    border: none;
  }
`;

const BrightnessSlider = styled.input`
  width: 120px;
  height: 4px;
  border-radius: 2px;
  outline: none;
  opacity: 0.7;
  transition: opacity 0.2s;
  appearance: none;
  -webkit-appearance: none;

  &:hover {
    opacity: 1;
  }

  &::-webkit-slider-thumb {
    appearance: none;
    -webkit-appearance: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ffffff;
    cursor: pointer;
    border: none;
  }

  &::-moz-range-thumb {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ffffff;
    cursor: pointer;
    border: none;
  }
`;

// Add scroll indicator components after the existing styled components
const ScrollIndicator = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  background: #000000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  pointer-events: auto;
  cursor: pointer;
  transition: opacity 0.3s, background-color 0.2s, transform 0.1s;
  
  &:hover {
    background: #1a1a1a;
  }
  
  &:active {
    transform: translateY(-50%) scale(0.95);
  }
  
  &.left {
    left: 5px;
  }
  
  &.right {
    right: 5px;
  }
  
  svg {
    width: 10px;
    height: 10px;
    
    path {
      stroke: #FF4500;
      stroke-width: 1.5;
    }
  }
`;

const ScrollableContainer = styled.div`
  position: relative;
  
  &.show-left-indicator ${ScrollIndicator}.left {
    opacity: 1;
  }
  
  &.show-right-indicator ${ScrollIndicator}.right {
    opacity: 1;
  }
  
  ${ScrollIndicator} {
    opacity: 0;
  }
`;

const FooterBar = (props) => {
    const { 
        isHome, 
        isVisible = true, 
        activeTab, 
        activeNavItem: activeNavItemProp, 
        onCategoryChange,
        chatMessages: chatMessagesProp,
        setChatMessages: setChatMessagesProp,
        isTyping: isTypingProp,
        setIsTyping: setIsTypingProp,
        typingBuffer: typingBufferProp,
        setTypingBuffer: setTypingBufferProp,
        isThinking: isThinkingProp,
        setIsThinking: setIsThinkingProp,
        onMessageSent,
        isChatMaximized,
        onMaximizeToggle,
        onMinimize,
        onNewChat
    } = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const messagesEndRef = useRef(null);
    const { confirmState, showConfirm, handleClose: confirmHandleClose, handleConfirm: confirmHandleConfirm } = useConfirm();

    const [isChatExpanded, setIsChatExpanded] = useState(false);
    
    // For homepage with tab system: chat is only "expanded" when isChatExpanded is true AND on chat tab
    // For other pages: use the internal isChatExpanded state
    const isActuallyChatExpanded = isHome && activeTab ? (activeTab === 'chat' && isChatExpanded) : isChatExpanded;
    const [isFooterEdit, setFootEdit] = useState(false);
    const [conversationId, setId] = useState('');
    const [messagesLocal, setMessagesLocal] = useState([]);
    const [isTypingLocal, setIsTypingLocal] = useState(false);
    const [typingBufferLocal, setTypingBufferLocal] = useState('');
    const typingTimeoutsRef = useRef([]); // Store typing timeouts for cleanup
    const activeTypingConversationRef = useRef(null); // Track which conversation is actively typing
    
    // Use prop state when on home page with new tab system, otherwise use local state
    const useHomepageState = isHome && activeTab && chatMessagesProp !== undefined;
    // Convert homepage messages format (role/text) to internal format (type/content) for compatibility
    const messages = useHomepageState 
        ? chatMessagesProp.map(m => ({ type: m.role, content: m.text, ...m }))
        : messagesLocal;
    const setMessages = useHomepageState ? (msgsOrUpdater) => {
        if (typeof msgsOrUpdater === 'function') {
            // It's an updater function like: prev => [...prev, newMsg]
            setChatMessagesProp(prev => {
                console.log('🔄 setMessages updater called, prev length:', prev.length);
                const updated = msgsOrUpdater(prev);
                console.log('🔄 After msgsOrUpdater, updated length:', updated.length);
                const formatted = updated.map(m => ({ 
                    role: m.type || m.role, 
                    text: m.content || m.text,
                    images: m.images,
                    hiddenImages: m.hiddenImages,
                    isThinking: m.isThinking,
                    // Preserve tour-specific properties
                    isTourMessage: m.isTourMessage,
                    showOptions: m.showOptions,
                    options: m.options,
                    showQuestions: m.showQuestions,
                    isNavigationMessage: m.isNavigationMessage,
                    navigationId: m.navigationId
                }));
                console.log('🔄 After formatting, formatted length:', formatted.length);
                console.log('🔄 Last message:', formatted[formatted.length - 1]);
                return formatted;
            });
        } else {
            // It's a direct array
            const formatted = msgsOrUpdater.map(m => ({ 
                role: m.type || m.role, 
                text: m.content || m.text,
                images: m.images,
                hiddenImages: m.hiddenImages,
                isThinking: m.isThinking,
                // Preserve tour-specific properties
                isTourMessage: m.isTourMessage,
                showOptions: m.showOptions,
                options: m.options,
                showQuestions: m.showQuestions,
                isNavigationMessage: m.isNavigationMessage,
                navigationId: m.navigationId
            }));
            setChatMessagesProp(formatted);
        }
    } : setMessagesLocal;
    const isTypingState = useHomepageState ? isTypingProp : isTypingLocal;
    const setIsTypingState = useHomepageState ? setIsTypingProp : setIsTypingLocal;
    const typingBuffer = useHomepageState ? typingBufferProp : typingBufferLocal;
    const setTypingBuffer = useHomepageState ? setTypingBufferProp : setTypingBufferLocal;
    
    // Use thinking state from props on homepage, local otherwise
    const [isThinkingLocal, setIsThinkingLocal] = useState(false);
    const isThinking = useHomepageState ? isThinkingProp : isThinkingLocal;
    const setIsThinking = useHomepageState ? setIsThinkingProp : setIsThinkingLocal;
    
    const [userInput, setUserInput] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isCooldown, setIsCooldown] = useState(false); // Prevent rapid interactions
    const [conversationHistory, setConversationHistory] = useState([]);
    // Use ref instead of state to persist across re-renders
    const activeChatSessionRef = useRef(null);
    const [activeChatSession, setActiveChatSession] = useState(null); // Track active chat session

    const [uploadedImages, setUploadedImages] = useState([]);
    const [hasDigestToShow, setHasDigestToShow] = useState(false);
    const [hasSetupToShow, setHasSetupToShow] = useState(false);
    const [isOnboardingMode, setIsOnboardingMode] = useState(false);
    const [isTourMode, setIsTourMode] = useState(() => isTourActive());
    const [currentTourSection, setCurrentTourSectionState] = useState(null);
    const [isNavigatingTour, setIsNavigatingTour] = useState(false);
    
    // Use sessionStorage to persist dismissal across component remounts
    const [digestDismissedThisSession, setDigestDismissedThisSession] = useState(() => {
        return sessionStorage.getItem('digestDismissedThisSession') === 'true';
    });
    
    // Helper to update dismissal flag in both state and sessionStorage
    const updateDigestDismissed = (dismissed) => {
        setDigestDismissedThisSession(dismissed);
        sessionStorage.setItem('digestDismissedThisSession', dismissed.toString());
    };
    
    // Helper function to get cached prompts synchronously
    const getCachedPresetPrompts = () => {
        try {
            const userId = getCurrentUserId();
            if (userId) {
                // Check memory cache first
                const memoryCache = window.dizeePresetPromptsCache;
                if (memoryCache && isCacheValid(memoryCache, userId)) {
                    console.log('🚀 Loading preset prompts from global memory cache');
                    return memoryCache.data.filter(prompt => prompt.enabled) || [];
                }
                
                // Check localStorage cache
                const cached = localStorage.getItem('dizee_preset_prompts_cache');
                if (cached) {
                    const cacheData = JSON.parse(cached);
                    if (isCacheValid(cacheData, userId)) {
                        console.log('🚀 Loading preset prompts from localStorage cache');
                        // Update global cache for next time
                        window.dizeePresetPromptsCache = cacheData;
                        return cacheData.data.filter(prompt => prompt.enabled) || [];
                    }
                }
            }
            console.log('⚠️ No cached preset prompts found, will load from server');
        } catch (error) {
            console.warn('Failed to load cached preset prompts:', error);
        }
        return [];
    };

    const getCachedCustomPrompts = () => {
        try {
            const userId = getCurrentUserId();
            if (userId) {
                // Check memory cache first
                const memoryCache = window.dizeeCustomPromptsCache;
                if (memoryCache && isCacheValid(memoryCache, userId)) {
                    return memoryCache.data.filter(prompt => prompt.enabled !== false) || [];
                }
                
                // Check localStorage cache
                const cached = localStorage.getItem('dizee_custom_prompts_cache');
                if (cached) {
                    const cacheData = JSON.parse(cached);
                    if (isCacheValid(cacheData, userId)) {
                        return cacheData.data.filter(prompt => prompt.enabled !== false) || [];
                    }
                }
            }
        } catch (error) {
            console.warn('Failed to load cached custom prompts:', error);
        }
        return [];
    };

    // Helper functions for cache validation and user ID
    const getCurrentUserId = () => {
        try {
            const token = localStorage.getItem('dizeeToken');
            if (!token) return null;
            const payload = JSON.parse(atob(token.split('.')[1]));
            return payload.id || payload.userId || payload.user_id;
        } catch (error) {
            return null;
        }
    };

    const isCacheValid = (cacheData, userId) => {
        if (!cacheData || !cacheData.timestamp || !cacheData.data) return false;
        if (cacheData.userId !== userId) return false;
        const now = Date.now();
        const duration = 30 * 60 * 1000; // 30 minutes
        return (now - cacheData.timestamp) < duration;
    };

    const [customPrompts, setCustomPrompts] = useState([]);
    const [presetPrompts, setPresetPrompts] = useState([]);
    const [activeNavItemLocal, setActiveNavItem] = useState(null); // Default to null to show static prompts
    
    // Form state for catalog prompts
    const [catalogFormType, setCatalogFormType] = useState(''); // 'release' or 'demo'
    const [catalogFormData, setCatalogFormData] = useState({
        songTitle: '',
        primaryArtists: [''],
        featuredArtists: [''],
        releaseStatus: 'upcoming',
        releaseDate: '',
        additionalInfo: ''
    });
    
    // Use prop from Landing page if on homepage with new tab system, otherwise use local state
    const activeNavItem = (isHome && activeTab) ? activeNavItemProp : activeNavItemLocal;
    
    // Handler to update category - uses callback if provided, otherwise local state
    const handleCategorySelect = (category) => {
        if (isHome && activeTab && onCategoryChange) {
            onCategoryChange(category);
        } else {
            setActiveNavItem(category);
        }
    };
    
    // Cleanup function to cancel all active typing timeouts
    const cancelTyping = () => {
        typingTimeoutsRef.current.forEach(timeout => clearTimeout(timeout));
        typingTimeoutsRef.current = [];
        setIsTypingState(false);
        setTypingBuffer('');
        setIsThinking(false);
    };
    
    // Typewriter effect for homepage
    const typewriterEffect = (text, onComplete) => {
        // Cancel any existing typing to prevent overlaps and glitches
        cancelTyping();
        
        // Clear thinking indicator and previous typing state
        setIsThinking(false);
        setTypingBuffer('');
        setIsTypingState(true);
        
        // Capture the current conversation ID for this typing session
        const typingForConversationId = loadedConversationId || conversationId;
        activeTypingConversationRef.current = typingForConversationId;
        console.log('🎯 Starting typing for conversation:', typingForConversationId);
        
        // Handle empty or undefined text - complete immediately
        if (!text || text.length === 0) {
            console.log('⚠️ Empty response text, completing immediately');
            onComplete(text || '');
            setIsTypingState(false);
            setTypingBuffer('');
            return;
        }
        
        const typeNext = (i, buf) => {
            // Check if typing should be complete
            if (i >= text.length) {
                // Typing complete - always complete to prevent hanging
                console.log('✅ Typing complete for conversation:', typingForConversationId);
                
                // Always call onComplete to add message - prevents hanging
                onComplete(buf);
                
                // Keep buffer visible and let glow fade slowly (6s transition on orb)
                const fadeTimeout = setTimeout(() => {
                    // Turn off typing state to start the slow fade
                    setIsTypingState(false);
                }, 500);
                
                // Clear buffer after glow fully fades
                const clearTimeout = setTimeout(() => {
                    setTypingBuffer('');
                }, 3000); // Reduced from 6500ms to 3000ms
                
                typingTimeoutsRef.current.push(fadeTimeout, clearTimeout);
                return;
            }
            
            const nextBuf = buf + text[i];
            setTypingBuffer(nextBuf);
            setIsTypingState(true);
            
            const ch = text[i];
            const isPause = /[\.,!?\n]/.test(ch) || ch === ' ';
            
            // Faster typing - reduced delays
            const baseDelay = (isPause ? 20 : 12);
            const randomVariation = Math.floor(Math.random() * (isPause ? 10 : 5));
            const delay = baseDelay + randomVariation;
            
            const timeout = setTimeout(() => typeNext(i + 1, nextBuf), delay);
            typingTimeoutsRef.current.push(timeout);
        };
        
        typeNext(0, '');
    };
    

    
    const fileInputRef = useRef(null);

    // AI action feedback states
    const [aiActions, setAiActions] = useState([]);
    const [showActionFeedback, setShowActionFeedback] = useState(false);

    // Scroll indicator states
    const [showLeftPrompts, setShowLeftPrompts] = useState(false);
    const [showRightPrompts, setShowRightPrompts] = useState(false);
    const [showLeftNav, setShowLeftNav] = useState(false);
    const [showRightNav, setShowRightNav] = useState(false);
    const [showLeftPagesPrompts, setShowLeftPagesPrompts] = useState(false);
    const [showRightPagesPrompts, setShowRightPagesPrompts] = useState(false);
    
    // Refs for scroll containers
    const promptsScrollRef = useRef(null);
    const navScrollRef = useRef(null);
    const pagesPromptsScrollRef = useRef(null);

    // Retouch and Color functionality states
    const [styleMenu, setStyleMenu] = useState(false);
    const [showCategoryFilter, setShowCategoryFilter] = useState(false);
    const [grayScaleBar, setGrayScaleBar] = useState(false);
    const [noiseBar, setNoiseBar] = useState(false);
    const [color, setColor] = useState(false);
    const [backgroundColor, setBackgroundColor] = useState(false);
    const [backgroundShade, setBackgroundShade] = useState(false);
    const [accentColor, setAccentColor] = useState(false);
    const [accentShade, setAccentShade] = useState(false);
    const [hue, setHue] = useState(0);
    const [brightness, setBrightness] = useState(50);
    const [hexBackground, setHexBackground] = useState("");
    const [hexAccent, setHexAccent] = useState("");

    // Get user article from Redux
    const userArticle = useSelector((state) => state.user.userArticle);
    let token = localStorage.getItem("dizeeToken");

    // Chat mode state - critical for proper state management
    const [chatMode, setChatMode] = useState('new'); // 'new', 'viewing', 'continuing'
    const [loadedConversationId, setLoadedConversationId] = useState(''); // Track which conversation is loaded

    // Scroll detection functions
    const checkScrollIndicators = (element, setShowLeft, setShowRight) => {
        if (!element) return;
        
        const { scrollLeft, scrollWidth, clientWidth } = element;
        setShowLeft(scrollLeft > 0);
        setShowRight(scrollLeft < scrollWidth - clientWidth - 1);
    };

    const handlePromptsScroll = () => {
        checkScrollIndicators(promptsScrollRef.current, setShowLeftPrompts, setShowRightPrompts);
    };

    const handleNavScroll = () => {
        checkScrollIndicators(navScrollRef.current, setShowLeftNav, setShowRightNav);
    };

    const handlePagesPromptsScroll = () => {
        checkScrollIndicators(pagesPromptsScrollRef.current, setShowLeftPagesPrompts, setShowRightPagesPrompts);
    };

    // Scroll functions for arrow clicks
    const scrollLeft = (ref) => {
        if (ref.current) {
            ref.current.scrollBy({ left: -200, behavior: 'smooth' });
        }
    };

    const scrollRight = (ref) => {
        if (ref.current) {
            ref.current.scrollBy({ left: 200, behavior: 'smooth' });
        }
    };

    // Arrow icon components
    const LeftArrow = () => (
        <svg viewBox="0 0 8 8" fill="none">
            <path d="M5 1L2 4L5 7" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );

    const RightArrow = () => (
        <svg viewBox="0 0 8 8" fill="none">
            <path d="M3 1L6 4L3 7" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );

    // Effect to check scroll indicators on mount and resize
    useEffect(() => {
        const checkAllScrollIndicators = () => {
            if (promptsScrollRef.current) {
                checkScrollIndicators(promptsScrollRef.current, setShowLeftPrompts, setShowRightPrompts);
            }
            if (navScrollRef.current) {
                checkScrollIndicators(navScrollRef.current, setShowLeftNav, setShowRightNav);
            }
            if (pagesPromptsScrollRef.current) {
                checkScrollIndicators(pagesPromptsScrollRef.current, setShowLeftPagesPrompts, setShowRightPagesPrompts);
            }
        };

        checkAllScrollIndicators();
        window.addEventListener('resize', checkAllScrollIndicators);
        
        return () => window.removeEventListener('resize', checkAllScrollIndicators);
    }, [customPrompts, activeNavItem]);

    // Desktop horizontal scroll on vertical wheel functionality
    useEffect(() => {
        const isDesktop = () => window.innerWidth >= 768; // Only enable on desktop

        const handleHorizontalScroll = (e) => {
            if (!isDesktop()) return;
            
            // Get the scroll container
            const container = e.currentTarget;
            
            // Check if there's scrollable content
            const hasScrollableContent = container.scrollWidth > container.clientWidth;
            
            // Check if this is primarily a vertical scroll
            const isVerticalScroll = Math.abs(e.deltaY) > Math.abs(e.deltaX);
            
            // Only prevent vertical scroll from affecting the page when there's horizontal content
            if (isVerticalScroll && hasScrollableContent) {
                e.preventDefault();
                
                // Calculate scroll amount (adjust multiplier for desired sensitivity)
                const scrollAmount = e.deltaY * -2;
                
                // Apply horizontal scroll
                container.scrollLeft += scrollAmount;
            }
        };

        const addWheelListeners = () => {
            if (promptsScrollRef.current) {
                promptsScrollRef.current.addEventListener('wheel', handleHorizontalScroll, { passive: false });
            }
            if (navScrollRef.current) {
                navScrollRef.current.addEventListener('wheel', handleHorizontalScroll, { passive: false });
            }
            if (pagesPromptsScrollRef.current) {
                pagesPromptsScrollRef.current.addEventListener('wheel', handleHorizontalScroll, { passive: false });
            }
        };

        const removeWheelListeners = () => {
            if (promptsScrollRef.current) {
                promptsScrollRef.current.removeEventListener('wheel', handleHorizontalScroll);
            }
            if (navScrollRef.current) {
                navScrollRef.current.removeEventListener('wheel', handleHorizontalScroll);
            }
            if (pagesPromptsScrollRef.current) {
                pagesPromptsScrollRef.current.removeEventListener('wheel', handleHorizontalScroll);
            }
        };

        // Add listeners
        addWheelListeners();

        // Cleanup on unmount
        return removeWheelListeners;
    }, []);

    // Helper functions for color conversion
    const hslToHex = (h, s, l) => {
        l /= 100;
        const a = s * Math.min(l, 1 - l) / 100;
        const f = n => {
            const k = (n + h / 30) % 12;
            const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
            return Math.round(255 * color).toString(16).padStart(2, '0');
        };
        return `#${f(0)}${f(8)}${f(4)}`;
    };

    // Add debounce to prevent rapid state updates
    const debouncedUpdateArticle = useCallback(
        debounce((newValue) => {
            dispatch(setUserArticle(newValue));
        }, 100),
        [dispatch]
    );

    // Update user article function
    const updateUserArticle = async (bool) => {
        if (token && userArticle) {
            dispatch(update_user_article_thunk({ 
                token, 
                body: { ...userArticle, unpublish: bool } 
            }));
        }
    };

    // Retouch functionality handlers
    const onChangeGrayScale = (e) => {
        try {
            const value = Math.min(Math.max(parseInt(e.target.value) || 0, 0), 100);
            dispatch(setUserArticle({
                ...userArticle,
                grayscale: value
            }));
        } catch (error) {
            console.error('Grayscale update error:', error);
        }
    };

    const onChangeNoise = (e) => {
        try {
            const value = Math.min(Math.max(parseInt(e.target.value) || 0, 0), 100);
            dispatch(setUserArticle({
                ...userArticle,
                noise: value
            }));
        } catch (error) {
            console.error('Noise update error:', error);
        }
    };

    const resetEffects = () => {
        dispatch(setUserArticle({
            ...userArticle,
            grayscale: 0,
            noise: 0
        }));
    };

    // Color functionality handlers
    const handleHueChangeBackground = (e) => {
        setHue(e.target.value);
        const hexColor = hslToHex(e.target.value, 100, brightness);
        const colorValue = hexColor.startsWith("#") ? hexColor.slice(1) : hexColor;
        setHexBackground(`#${colorValue}`);
        debouncedUpdateArticle({ ...userArticle, background: colorValue });
    };

    const handleBrightnessChangeBackground = (e) => {
        setBrightness(e.target.value);
        const hexColor = hslToHex(hue, 100, e.target.value);
        const colorValue = hexColor.startsWith("#") ? hexColor.slice(1) : hexColor;
        debouncedUpdateArticle({ ...userArticle, background: colorValue });
    };

    const handleHueChangeAccent = (e) => {
        setHue(e.target.value);
        const hexColor = hslToHex(e.target.value, 100, brightness);
        const colorValue = hexColor.startsWith("#") ? hexColor.slice(1) : hexColor;
        setHexAccent(`#${colorValue}`);
        dispatch(setUserArticle({ ...userArticle, accent: colorValue }));
    };

    const handleBrightnessChangeAccent = (e) => {
        setBrightness(e.target.value);
        const hexColor = hslToHex(hue, 100, e.target.value);
        const colorValue = hexColor.startsWith("#") ? hexColor.slice(1) : hexColor;
        dispatch(setUserArticle({ ...userArticle, accent: colorValue }));
    };

    const handleColorInput = (e) => {
        const value = e.target.value.toUpperCase();
        setHexBackground(value);
        if (value.length === 7 && value.startsWith('#')) {
            const colorValue = value.slice(1);
            debouncedUpdateArticle({ ...userArticle, background: colorValue });
        }
    };

    const handleAccentColorInput = (e) => {
        const value = e.target.value.toUpperCase();
        setHexAccent(value);
        if (value.length === 7 && value.startsWith('#')) {
            const colorValue = value.slice(1);
            dispatch(setUserArticle({ ...userArticle, accent: colorValue }));
        }
    };

    // Category-specific preset prompts - REMOVED: Now using database-loaded preset prompts

    // Static default prompts that appear when no category is selected
    const getDefaultStaticPrompts = () => {
        return [
            "Career Health Check",
            "Dizee Health Check",
            "Year in Review",
            "Connect Calendar",
            "Manage Team",
            "Teach Me Something New",
            "How Can I Better Utilize Dizee",
            "Restart Tutorial"
        ];
    };

    // Helper function to get user's workflows from localStorage
    const getUserWorkflows = () => {
        try {
            const reminders = JSON.parse(localStorage.getItem('userReminders') || '[]');
            
            // Group reminders by workflow
            const workflows = {};
            
            reminders.forEach(reminder => {
                // Skip quick reminders - they don't become prompts
                if (reminder.metadata?.quick_reminder) {
                    return;
                }
                
                const workflowId = reminder.releaseId;
                if (!workflows[workflowId]) {
                    workflows[workflowId] = {
                        id: workflowId,
                        name: reminder.releaseName,
                        type: reminder.metadata?.type === 'booking' ? 'show' : 'song',
                        date: reminder.releaseDate,
                        steps: []
                    };
                }
                workflows[workflowId].steps.push(reminder);
            });
            
            // Convert to array and sort by creation date (earliest first)
            return Object.values(workflows).sort((a, b) => new Date(a.date) - new Date(b.date));
        } catch (error) {
            console.error('Error loading workflows:', error);
            return [];
        }
    };

    // Get current prompts based on active nav item
    const getCurrentPrompts = () => {
        // If no category is selected, show static default prompts
        if (!activeNavItem) {
            return getDefaultStaticPrompts();
        }

        // Map activeNavItem to category name
        const categoryMap = {
            'daily': 'pages', // Daily uses pages category for prompts when digest not available
            'experts': 'experts',
            'pages': 'pages',
            'bookings': 'bookings',
            'catalog': 'catalog',
            'merch': 'merch',
            'analytics': 'analytics',
            'touring': 'touring', // Touring category for travel prompts
            'flows': 'flows',
            'custom': 'pages' // Custom uses pages category as fallback
        };
        
        const category = categoryMap[activeNavItem] || 'bookings';
        
        // Filter preset prompts by category and return their content
        const categoryPrompts = presetPrompts
            .filter(prompt => prompt.category === category)
            .sort((a, b) => a.order - b.order)
            .map(prompt => prompt.content);

        // For flows category, add dynamic workflow prompts
        if (category === 'flows') {
            const workflows = getUserWorkflows();
            const workflowPrompts = workflows.map(workflow => `${workflow.name} flow`);
            return [...categoryPrompts, ...workflowPrompts];
        }

        // If no category-specific prompts are found, fall back to static defaults
        return categoryPrompts.length > 0 ? categoryPrompts : getDefaultStaticPrompts();
    };

    const chatData = useSelector((state) => state.chatData);

    // Load custom prompts function
    const loadCustomPrompts = async () => {
        try {
            const prompts = await promptsApi.getUserPrompts();
            if (prompts) {
                // Filter for enabled prompts and add enabled property if not present
                const enabledPrompts = prompts
                    .map(prompt => ({
                        ...prompt,
                        enabled: prompt.enabled !== undefined ? prompt.enabled : true
                    }))
                    .filter(prompt => prompt.enabled);
                setCustomPrompts(enabledPrompts);
            }
        } catch (error) {
            console.error('Failed to load custom prompts:', error);
        }
    };

    // Load preset prompts function
    const loadPresetPrompts = async () => {
        try {
            const prompts = await presetPromptsApi.getPresetPrompts();
            if (prompts) {
                // Filter for enabled prompts only
                const enabledPresetPrompts = prompts.filter(prompt => prompt.enabled);
                setPresetPrompts(enabledPresetPrompts);
            }
        } catch (error) {
            console.error('Failed to load preset prompts:', error);
        }
    };

    // Load custom prompts
    useEffect(() => {
        loadCustomPrompts();
        loadPresetPrompts();
    }, []);

    // Listen for prompt updates
    useEffect(() => {
        const handlePromptsUpdate = () => {
            loadCustomPrompts();
            loadPresetPrompts();
        };

        const handleConversationLoaded = (event) => {
            // 🔧 FIXED: Set proper chat mode when loading old conversation
            const conversationId = event.detail?.conversationId;
            
            // 🚨 DEFENSIVE CHECK: Only process if we're not already in the middle of a chat interaction
            if (conversationId && !isLoading) {
                console.log('👁️ Old conversation loaded, switching to VIEWING mode:', conversationId);
                
                // 🔒 INVALIDATE SESSION: Prevent responses from previous conversation
                console.log('🚫 Invalidating chat session on conversation switch:', activeChatSessionRef.current);
                activeChatSessionRef.current = null;
                setActiveChatSession(null);
                
                // 🔧 Cancel typing to prevent glitches when switching conversations
                cancelTyping();
                
                setChatMode('viewing');
                setLoadedConversationId(conversationId);
                
                console.log('📍 Conversation switched to:', conversationId);
                
                // 🔧 For non-homepage pages: Force chat expansion immediately
                if (!useHomepageState) {
                    setIsChatExpanded(true);
                    console.log('💬 Chat expanded for non-homepage page');
                }
                // Note: For homepage, maximization is handled by switchToChatTab event from sidebar
                // to avoid toggling twice
            } else if (conversationId && isLoading) {
                console.log('⚠️ Conversation load event ignored - chat interaction in progress');
                return;
            }
        };

        const handleNewChatRequested = () => {
            console.log('🆕 New chat requested from sidebar, calling handleNewChat...');
            handleNewChat();
        };

        window.addEventListener('promptsUpdated', handlePromptsUpdate);
        window.addEventListener('conversationLoaded', handleConversationLoaded);
        window.addEventListener('newChatRequested', handleNewChatRequested);
        
        // Listen for catalog form submissions to send as natural AI messages
        const handleSendAIMessage = async (event) => {
            const { message, catalogId } = event.detail;
            console.log('📨 Received sendAIMessage event:', { message, catalogId });
            
            if (message) {
                console.log('📨 Sending catalog confirmation to AI:', message.substring(0, 100));
                
                // Directly send the message without relying on userInput state
                // This is similar to how preset prompts work
                
                // Add user message to chat immediately
                if (useHomepageState) {
                    setChatMessagesProp(prev => [...prev, {
                        role: 'user',
                        text: message
                    }]);
                } else {
                    setMessages(prev => [...prev, {
                        type: 'user',
                        content: message
                    }]);
                }
                
                // Store message in window for handleSendMessage to use (like digest prompts)
                window._catalogSubmitPrompt = message;
                window._skipNextUserMessage = true; // Skip validation since we're providing the message
                
                // Clear input field
                setUserInput('');
                
                // Trigger send
                console.log('📨 Triggering handleSendMessage...');
                await handleSendMessage();
                
                // Clean up
                delete window._catalogSubmitPrompt;
                delete window._skipNextUserMessage;
            }
        };
        window.addEventListener('sendAIMessage', handleSendAIMessage);
        
        return () => {
            window.removeEventListener('promptsUpdated', handlePromptsUpdate);
            window.removeEventListener('conversationLoaded', handleConversationLoaded);
            window.removeEventListener('newChatRequested', handleNewChatRequested);
            window.removeEventListener('sendAIMessage', handleSendAIMessage);
        };
    }, []);

    useEffect(() => {
        if (chatData.chatHistory && chatData.chatHistory.length > 0) {
            // 📊 PRIORITY CHECK: If daily digest should show, start with fresh chat instead of loading history
            // This ensures users see their digest at 5 AM even if they have chat history
            // BUT: Don't show if user explicitly dismissed it this session via "New Chat"
            // Use sync version for immediate check, then verify with async
            if (shouldShowDailyDigestSync() && !digestDismissedThisSession) {
                console.log('📊 Daily digest should show - starting with fresh chat instead of loading history');
                dispatch(clearChatHistoryOnly()); // Clear Redux chat history
                setMessages([]);
                setConversationHistory([]);
                setId('');
                setHasDigestToShow(true);
                
                // Verify with backend (async)
                shouldShowDailyDigest().then(shouldShow => {
                    if (shouldShow && !digestDismissedThisSession) {
                        console.log('📊 Backend confirmed: digest should show');
                        setHasDigestToShow(true);
                    } else {
                        console.log('📊 Backend says digest should not show - hiding button');
                        setHasDigestToShow(false);
                    }
                });
                return;
            }
            
            console.log('📚 CURSOR-STYLE: Loading conversation history:', chatData.chatHistory.length, 'messages');
            
            // CURSOR-STYLE: Preserve all message data including images
            let firstImageMessageFound = false;
            const formattedMessages = chatData.chatHistory.map((item, index) => {
                console.log(`📝 Loading message ${index}:`, {
                    type: item.type,
                    hasMessage: !!item.message,
                    hasImages: !!(item.images && item.images.length > 0),
                    imageCount: item.images?.length || 0
                });
                
                // CURSOR-STYLE: Only show images in the FIRST user message with images
                // All subsequent user messages with images should hide them (context only)
                const hasImages = !!(item.images && item.images.length > 0);
                const isUserMessage = item.type === 'user';
                
                let visibleImages = [];
                let hiddenImages = [];
                
                if (hasImages && isUserMessage) {
                    if (!firstImageMessageFound) {
                        // First user message with images - show them
                        visibleImages = item.images || [];
                        firstImageMessageFound = true;
                        console.log(`👁️ First image message (${index}) - images will be VISIBLE`);
                    } else {
                        // Subsequent user messages with images - hide them
                        hiddenImages = item.images || [];
                        console.log(`🫥 Follow-up image message (${index}) - images will be HIDDEN`);
                    }
                }
                
                return {
                    type: item.type,
                    content: item.message,
                    images: visibleImages,
                    hiddenImages: hiddenImages
                };
            });
            
            // Use the SAME format for both display and backend
            setMessages(formattedMessages);
            setConversationHistory(formattedMessages);
            setId(chatData.chatHistory[0]?.conversationId);
            
            if (chatData.isOpen) {
                setIsChatExpanded(true);
            }
            
            console.log('✅ CURSOR-STYLE: Conversation loaded consistently');
        } else {
            if (!chatData.isOpen) {
                setMessages([]);
                setConversationHistory([]);
                setId('');
                setIsChatExpanded(false);
            }
        }
    }, [chatData]);

    useEffect(() => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [messages, isLoading]);

    // Sync with Redux chat state
    useEffect(() => {
        // If chat is being opened and we have messages, expand immediately
        if (chatData.isOpen && chatData.chatHistory && chatData.chatHistory.length > 0) {
            setIsChatExpanded(true);
        } else if (chatData.isOpen) {
            setIsChatExpanded(true);
        } else {
            setIsChatExpanded(chatData.isOpen);
        }
    }, [chatData.isOpen, chatData.chatHistory, digestDismissedThisSession]);

    // Daily Digest - Poll periodically to check if digest should show (5 AM auto-trigger only)
    useEffect(() => {
        const checkDigest = async () => {
            // Don't re-show digest if user explicitly dismissed it this session via "New Chat"
            if (digestDismissedThisSession) {
                console.log('📊 Digest was dismissed this session - not showing again');
                return;
            }
            
            if (messages.length === 0) {
                const shouldShow = await shouldShowDailyDigest();
                if (shouldShow) {
                    console.log('📊 Daily digest button should show (5 AM trigger)');
                    setHasDigestToShow(true);
                } else {
                    console.log('📊 Digest should not show (already seen today)');
                    setHasDigestToShow(false);
                }
            } else {
                // Hide when messages exist
                setHasDigestToShow(false);
            }
        };
        
        checkDigest();
        
        // Poll every 30 seconds to check if digest should appear
        const intervalId = setInterval(checkDigest, 30000);
        
        return () => clearInterval(intervalId);
    }, [messages.length, digestDismissedThisSession]); // Re-check when messages change or dismissal flag changes
    
    // Hide digest button when messages appear
    useEffect(() => {
        if (messages.length > 0) {
            setHasDigestToShow(false);
            setHasSetupToShow(false); // Also hide setup button
        }
    }, [messages.length]);
    
    // Account Setup - Check if setup should show (once after tutorial completion)
    // Note: Digest takes priority over setup, so setup only shows if no digest available
    useEffect(() => {
        const checkSetup = () => {
            if (shouldShowAccountSetup() && messages.length === 0 && !hasDigestToShow) {
                console.log('🎯 Account setup button should show');
                setHasSetupToShow(true);
            }
        };
        
        checkSetup();
        
        // Listen for tutorial completion event
        const handleTutorialComplete = () => {
            console.log('🎯 Tutorial completed event received, checking setup immediately');
            setTimeout(checkSetup, 100); // Small delay to ensure localStorage is set
        };
        window.addEventListener('tutorialCompleted', handleTutorialComplete);
        
        // Poll every 5 seconds as backup
        const intervalId = setInterval(checkSetup, 5000);
        
        return () => {
            clearInterval(intervalId);
            window.removeEventListener('tutorialCompleted', handleTutorialComplete);
        };
    }, [messages.length, hasDigestToShow]);
    
    // Function to show the digest when user clicks
    const handleShowDigest = () => {
        // Create the daily digest prompt
        const digestPrompt = `Provide my daily digest. Start with the intro line, then add ONE blank line, then each section with ONE blank line after each section header and ONE blank line between sections.

Here's your daily digest, organized with the information you've requested:
[BLANK LINE]
Tasks Due Today and Tomorrow
[BLANK LINE]
• [Check reminders/tasks and list OR "Currently, there are no active reminders or tasks due today or tomorrow."]
[BLANK LINE]
Shows This Week
[BLANK LINE]  
• [Check bookings for confirmed shows in next 7 days OR "You have no shows confirmed for the next 7 days."]
[BLANK LINE]
Releases This Month
[BLANK LINE]
• [Check catalog for upcoming releases this month OR "No releases scheduled for this month."]
[BLANK LINE]
Pending Offers
[BLANK LINE]
• [Check bookings for pending offers OR "There are no pending booking offers at this time."]

RULES: Where it says [BLANK LINE], you must press Enter twice to create an empty line. Use • bullets ONLY.`;

        // Mark as shown and hide button immediately
        setHasDigestToShow(false);
        markDigestAsShown(); // Updates backend - prevents 5 AM trigger from showing again today
        setActiveNavItem(null); // Clear Daily tab selection
        updateDigestDismissed(false); // Reset dismissal flag since user is viewing the digest
        
        // Immediately add a "Thinking..." message so UI switches (hides prompts/categories, shows expand/simplify buttons)
        if (useHomepageState) {
            setIsThinking(true);
            // Add a placeholder message so messages.length > 0 (triggers UI switch)
            setMessages(prev => [...prev, { role: 'assistant', text: '', isThinking: true }]);
        } else {
            setMessages(prev => [...prev, { type: 'assistant', content: 'Thinking...', isThinking: true }]);
        }
        
        // Use existing send message flow but skip showing user message
        window._skipNextUserMessage = true;
        window._digestPrompt = digestPrompt; // Store prompt for use in handleSendMessage
        
        // Set the input
        setUserInput(digestPrompt);
        
        // Wait for state update, then send
        setTimeout(() => {
            handleSendMessage();
        }, 100);
    };
    
    // Function to show the account setup when user clicks
    const handleShowSetup = () => {
        console.log('🚀 Starting interactive tour in chat...');
        
        // Mark as completed and hide button immediately
        setHasSetupToShow(false);
        markSetupAsCompleted();
        
        // Activate tour mode
        setIsTourMode(true);
        setTourActive(true);
        
        // Clear existing messages and add welcome
        const welcome = getWelcomeMessage();
        setMessages([welcome]);
        
        // Expand chat to show tour
        if (useHomepageState) {
            dispatch(openChat());
            // Also trigger maximize if there's a handler
            if (onMaximizeToggle) {
                onMaximizeToggle(true);
            }
        } else {
            setIsChatExpanded(true);
            dispatch(openChat());
        }
        
        console.log('✅ Tour started in chat interface');
    };
    
    // Handle tour option selection (Bookings, Catalog, etc)
    const handleTourOptionSelect = (option) => {
        console.log('📍 Tour option selected:', option);
        
        if (option === 'continue') {
            handleTourContinue();
            return;
        }
        
        if (option === 'menu') {
            handleTourMenu();
            return;
        }
        
        if (option === 'done') {
            handleTourDone();
            return;
        }
        
        // Handle section selection (bookings, catalog, etc)
        handleTourSectionSelect(option);
    };
    
    // Handle section selection
    const handleTourSectionSelect = (sectionName) => {
        setCurrentTourSectionState(sectionName);
        setCurrentTourSection(sectionName);
        
        const tourSection = TOUR_CONTENT[sectionName];
        if (!tourSection) return;
        
        // Add user's choice message
        const sectionInfo = TOUR_SECTIONS[sectionName];
        const startTime = Date.now();
        const navigationId = `nav-${Date.now()}`; // Unique ID for this navigation message
        
        setMessages(prev => [...prev, {
            role: 'user',
            text: `${sectionInfo.icon} ${sectionInfo.name}`,
            isTourMessage: true
        }]);
        
        // Show intro message with navigation ID
        setTimeout(() => {
            setMessages(prev => [...prev, {
                role: 'assistant',
                text: tourSection.intro.navigationText || tourSection.intro.text.split('\n\n')[0],
                isTourMessage: true,
                isNavigationMessage: true,
                navigationId: navigationId
            }]);
            
            // Navigate after delay
            if (tourSection.intro.navigate) {
                setIsNavigatingTour(true);
                setTimeout(() => {
                    navigate(tourSection.intro.navigate);
                    
                    // Update the navigation message to show completion
                    const elapsedTime = Math.round((Date.now() - startTime) / 1000);
                    setMessages(prev => prev.map(msg => 
                        msg.navigationId === navigationId 
                            ? {
                                ...msg,
                                text: msg.text.replace('Navigating to', 'Navigated to') + ` (${elapsedTime}s)`
                              }
                            : msg
                    ));
                    
                    // Show on arrival message after navigation
                    setTimeout(() => {
                        setMessages(prev => [...prev, {
                            role: 'assistant',
                            text: tourSection.onArrival.text,
                            showOptions: tourSection.onArrival.showOptions,
                            options: tourSection.onArrival.options,
                            isTourMessage: true
                        }]);
                        setIsNavigatingTour(false);
                    }, 800);
                }, tourSection.intro.delay || 1500);
            }
        }, 300);
    };
    
    // Handle continue button
    const handleTourContinue = () => {
        setMessages(prev => [...prev, {
            role: 'user',
            text: 'Continue to next section',
            isTourMessage: true
        }]);
        
        setTimeout(() => {
            const nextSection = getNextSection(currentTourSection);
            
            if (nextSection) {
                setMessages(prev => [...prev, {
                    role: 'assistant',
                    text: QUICK_RESPONSES.continue,
                    isTourMessage: true
                }]);
                
                setTimeout(() => {
                    handleTourSectionSelect(nextSection);
                }, 800);
            } else {
                // Tour complete!
                const completion = getCompletionMessage();
                setMessages(prev => [...prev, completion]);
                completeTour();
                setTourActive(false);
            }
        }, 300);
    };
    
    // Handle menu button
    const handleTourMenu = () => {
        setMessages(prev => [...prev, {
            role: 'user',
            text: 'Reload menu',
            isTourMessage: true
        }]);
        
        setTimeout(() => {
            setMessages(prev => [...prev, {
                role: 'assistant',
                text: QUICK_RESPONSES.menu,
                isTourMessage: true,
                showOptions: true,
                options: ['menu']
            }]);
            
            setTimeout(() => {
                const menu = getMenuMessage();
                setMessages(prev => [...prev, menu]);
            }, 500);
        }, 300);
    };
    
    // Handle done button
    const handleTourDone = () => {
        setMessages(prev => [...prev, {
            role: 'user',
            text: "I'm ready to start!",
            isTourMessage: true
        }]);
        
        setTimeout(() => {
            const completion = getCompletionMessage();
            setMessages(prev => [...prev, completion]);
            completeTour();
            setTourActive(false);
        }, 300);
    };
    
    // Handle preset question selection
    const handleTourQuestionSelect = (question) => {
        console.log('❓ Tour question asked:', question);
        
        // Add user's question
        setMessages(prev => [...prev, {
            role: 'user',
            text: question,
            isTourMessage: true
        }]);
        
        // Get answer
        const answer = QUESTION_ANSWERS[question];
        if (answer) {
            setTimeout(() => {
                setMessages(prev => [...prev, {
                    role: 'assistant',
                    text: answer.text,
                    showOptions: answer.showOptions,
                    options: answer.options,
                    isTourMessage: true
                }]);
            }, 400);
        }
    };
    
    // Exit tour mode
    const handleExitTour = async () => {
        const confirmed = await showConfirm({
            title: 'Exit Tour',
            message: 'Are you sure you want to exit the tour?',
            confirmLabel: 'Exit Tour',
            cancelLabel: 'Cancel'
        });
        
        if (confirmed) {
            console.log('🚪 Exiting tour mode');
            setIsTourMode(false);
            setTourActive(false);
            setCurrentTourSectionState(null);
            setMessages([]);
            clearTourMessages(); // Clear saved tour messages from sessionStorage
            
            // If on homepage, collapse chat to show orb
            if (useHomepageState && onMaximizeToggle) {
                onMaximizeToggle(false); // Collapse chat to show orb
            } else {
                // Navigate back to chat/home if not already on homepage
                navigate('/');
            }
            
            // Return to wherever they were
            console.log('✅ Tour exited, chat cleared');
        }
    };
    
    // Go back to tour chat
    const handleBackToTourChat = () => {
        console.log('🔙 Returning to tour chat');
        navigate('/');
        // Chat should still have tour messages
    };
    
    // Function to dismiss setup
    const handleDismissSetup = () => {
        setHasSetupToShow(false);
        markSetupAsCompleted();
        console.log('🎯 Account setup dismissed by user');
    };

    const handleExpandChat = () => {
        // For homepage with new tab system, tabs are handled in the content area
        // Just expand the chat overlay
        setIsChatExpanded(true);
        dispatch(openChat());
    };

    const handleMinimizeChat = () => {
        // 🔒 INVALIDATE SESSION: Prevent contamination from pending responses
        console.log('🚫 Invalidating chat session on minimize:', activeChatSessionRef.current);
        activeChatSessionRef.current = null;
        setActiveChatSession(null);
        
        // Clear UI state
        setUserInput('');
        
        // Clear uploaded images and revoke URLs to prevent memory leaks
        uploadedImages.forEach(image => {
            if (image.url) {
                URL.revokeObjectURL(image.url);
            }
        });
        setUploadedImages([]);
        
        // 🔧 FIXED: Always clear conversation state when minimizing
        // This prevents old conversations from contaminating new ones
        setMessages([]);
        setConversationHistory([]);
        setId('');
        setChatMode('new');
        setLoadedConversationId('');
        dispatch(setChatHistory([]));
        
        console.log('📝 Chat minimized - all state cleared to prevent contamination');
        
        // Close the chat
        setIsChatExpanded(false);
        dispatch(closeChat());
    };

    const handleNewChat = () => {
        console.log('🆕 handleNewChat called - BEFORE clearing state:', {
            currentConversationId: conversationId,
            currentLoadedConversationId: loadedConversationId,
            currentChatMode: chatMode,
            messagesLength: messages.length,
            conversationHistoryLength: conversationHistory.length
        });
        
        // 🔧 CRITICAL: Cancel any active typing animation
        cancelTyping();
        
        // 🔒 INVALIDATE SESSION: Prevent contamination from pending responses
        console.log('🚫 Invalidating chat session on new chat:', activeChatSessionRef.current);
        activeChatSessionRef.current = null;
        setActiveChatSession(null);
        
        // Clear local state completely
        setMessages([]);
        setConversationHistory([]);
        setId(''); // This is the conversationId - critical to reset!
        setUserInput('');
        setIsLoading(false);
        
        // Clear uploaded images and revoke URLs to prevent memory leaks
        uploadedImages.forEach(image => {
            if (image.url) {
                URL.revokeObjectURL(image.url);
            }
        });
        setUploadedImages([]);
        
        // Clear AI action feedback
        setAiActions([]);
        setShowActionFeedback(false);
        
        // 📊 If digest button was showing OR Daily tab is active, mark it as dismissed for this session
        // This prevents polling from re-showing it after "New Chat"
        if (hasDigestToShow || activeNavItem === 'daily') {
            console.log('📊 User dismissed digest via "New Chat" - marking as dismissed for session');
            updateDigestDismissed(true);
        }
        
        // Clear digest button and Daily tab selection
        setHasDigestToShow(false);
        // Use handleCategorySelect to properly clear activeNavItem (handles both prop and local state)
        handleCategorySelect(null);
        
        // 🔧 FIXED: Set proper chat mode for new conversation
        setChatMode('new');
        setLoadedConversationId('');
        
        // Use clearChatHistory instead of setChatHistory to completely reset Redux state
        dispatch(clearChatHistory());
        
        // Keep the chat open for the new conversation
        // User clicked "New Chat" so they want to start chatting
        setIsChatExpanded(true);
        dispatch(openChat());
        
        console.log('🆕 New chat started - AFTER clearing state:', {
            conversationIdAfterClear: conversationId, // This might still show old value due to React batching
            loadedConversationIdAfterClear: loadedConversationId,
            chatModeAfterClear: chatMode,
            message: 'All state cleared, mode set to NEW'
        });
    };

    const handleClearAllForNewChat = () => {
        console.log('🆕 handleClearAllForNewChat called - Clearing for homepage new chat');
        
        // 🔧 CRITICAL: Cancel any active typing animation
        cancelTyping();
        
        // 🔒 INVALIDATE SESSION: Prevent contamination from pending responses
        activeChatSessionRef.current = null;
        setActiveChatSession(null);
        
        // If parent provides onNewChat handler, use it for coordinated clearing
        if (useHomepageState && onNewChat) {
            // Let parent handle the state clearing for synchronized animation
            onNewChat();
        }
        
        // Clear local FooterBar state
        setConversationHistory([]);
        setId(''); // This is the conversationId - critical to reset!
        setUserInput('');
        setIsLoading(false);
        
        // Clear uploaded images and revoke URLs to prevent memory leaks
        uploadedImages.forEach(image => {
            if (image.url) {
                URL.revokeObjectURL(image.url);
            }
        });
        setUploadedImages([]);
        
        // Clear AI action feedback
        setAiActions([]);
        setShowActionFeedback(false);
        
        // 📊 If digest button was showing OR Daily tab is active, mark it as dismissed for this session
        // This prevents polling from re-showing it after "New Chat"
        if (hasDigestToShow || activeNavItem === 'daily') {
            console.log('📊 User dismissed digest via "New Chat" - marking as dismissed for session');
            updateDigestDismissed(true);
        }
        
        // Clear digest button and Daily tab selection
        setHasDigestToShow(false);
        // Use handleCategorySelect to properly clear activeNavItem (handles both prop and local state)
        handleCategorySelect(null);
        
        // 🔧 FIXED: Set proper chat mode for new conversation
        setChatMode('new');
        setLoadedConversationId('');
        
        // Use clearChatHistory instead of setChatHistory to completely reset Redux state
        dispatch(clearChatHistory());
        
        console.log('🆕 New chat started on homepage - All state cleared');
    };

    const handleSendMessage = async () => {
        // Use stored digest/setup/catalog prompt if available and userInput hasn't updated yet
        const messageToSend = window._digestPrompt || window._setupPrompt || window._catalogSubmitPrompt || userInput;
        
        // Clear the stored prompts
        if (window._digestPrompt) {
            delete window._digestPrompt;
        }
        if (window._setupPrompt) {
            delete window._setupPrompt;
        }
        if (window._catalogSubmitPrompt) {
            delete window._catalogSubmitPrompt;
        }
        
        // Skip validation if this is a digest/setup message (it's being set async)
        if (!window._skipNextUserMessage && ((!messageToSend.trim() && uploadedImages.length === 0) || isLoading)) return;

        // Clear any existing typing state before starting new message
        if (useHomepageState) {
            // If currently typing, immediately finalize the typing buffer as a complete message
            if (typingBuffer && typingBuffer.length > 0) {
                setMessages(prev => {
                    // Only add if not already in the array
                    const exists = prev.some(m => m.role === 'assistant' && m.text === typingBuffer);
                    if (exists) return prev;
                    return [...prev, { role: 'assistant', text: typingBuffer }];
                });
            }
            setTypingBuffer('');
            setIsTypingState(false);
        }

        // 🔒 SESSION TRACKING: Generate unique session ID to prevent contamination
        const sessionId = `chat_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        activeChatSessionRef.current = sessionId;
        setActiveChatSession(sessionId);
        console.log('🎯 Starting new chat session:', sessionId);

        // 🔧 FIXED: Proper new chat detection based on chat mode
        const isNewChat = chatMode === 'new';
        // 🚨 FORCE empty string for new chats regardless of state values
        const currentConversationId = isNewChat ? '' : (loadedConversationId || conversationId);
        
        console.log('🔍 Conversation ID calculation:', {
            isNewChat,
            chatMode,
            conversationId,
            loadedConversationId,
            calculatedId: currentConversationId,
            willForceEmpty: isNewChat ? 'YES' : 'NO'
        });
        
        // If we're in viewing mode and user sends a message, switch to continuing mode
        if (chatMode === 'viewing') {
            setChatMode('continuing');
            console.log('🔄 Switching from VIEWING to CONTINUING mode');
        }
        
        // 🚨 CRITICAL CHECK: Detect if user is trying to start new chat without clearing state
        if (chatMode === 'new' && (conversationId || loadedConversationId)) {
            console.error('🚨 CRITICAL ISSUE: chatMode is NEW but conversation IDs still exist!', {
                chatMode,
                conversationId,
                loadedConversationId,
                shouldBothBeEmpty: 'YES - this indicates state was not properly cleared'
            });
            
            // 🔧 AUTO-FIX: Force clear the conversation IDs if chatMode is 'new'
            console.log('🔧 AUTO-FIXING: Clearing conversation IDs since chatMode is NEW');
            setId('');
            setLoadedConversationId('');
        }

        console.log('💬 Chat state analysis:', {
            chatMode,
            loadedConversationId,
            isNewChat,
            messagesLength: messages.length,
            conversationHistoryLength: conversationHistory.length,
            currentConversationId,
            userInput: userInput.substring(0, 50) + '...',
            willCreateNewConversation: isNewChat,
            willContinueExisting: !isNewChat && currentConversationId,
            // 🔍 DETAILED ID TRACKING
            conversationIdState: conversationId,
            loadedConversationIdState: loadedConversationId,
            chatModeState: chatMode,
            idCalculationBreakdown: {
                isNewChat,
                emptyStringIfNew: isNewChat ? '' : 'NOT_EMPTY',
                loadedConversationId: loadedConversationId || 'NULL',
                fallbackConversationId: conversationId || 'NULL',
                finalResult: currentConversationId || 'EMPTY_STRING'
            }
        });

        // CURSOR-STYLE: Auto-include last image for follow-ups (like Cursor does)
        let imagesToSend = uploadedImages;
        
                // If no new images uploaded, check if we should re-use the last image from conversation
        if (uploadedImages.length === 0) {
            console.log(`🔍 CURSOR-STYLE: Looking for previous images in ${messages.length} messages`);
            
            // Find the most recent user message with images that have valid data URLs
            for (let i = messages.length - 1; i >= 0; i--) {
                if (messages[i].type === 'user') {
                    // Check both visible images and hidden images
                    const allPreviousImages = [...(messages[i].images || []), ...(messages[i].hiddenImages || [])];
                    
                    console.log(`🔍 Message ${i} analysis:`, {
                        type: messages[i].type,
                        hasImages: allPreviousImages.length > 0,
                        imageCount: allPreviousImages.length,
                        images: allPreviousImages.map(img => ({
                            name: img.name,
                            urlType: img.url?.startsWith('data:image/') ? 'VALID-data-url' : 
                                    img.url?.startsWith('blob:') ? 'INVALID-blob-url' : 
                                    img.url?.startsWith('data:') ? 'data-url-other' : 'unknown',
                            urlPreview: img.url?.substring(0, 60) + '...',
                            hasFile: !!img.file
                        }))
                    });
                    
                    if (allPreviousImages.length > 0) {
                        const validImages = allPreviousImages.filter(img => 
                            img.url && img.url.startsWith('data:image/')
                        );
                        
                        if (validImages.length > 0) {
                            imagesToSend = validImages;
                            console.log(`✅ CURSOR-STYLE: Found ${validImages.length} valid images for auto-injection from message ${i}`);
                            console.log(`🖼️ Using images:`, validImages.map(img => ({
                                name: img.name,
                                urlPreview: img.url.substring(0, 60) + '...'
                            })));
                            break;
                        } else {
                            console.log(`❌ Message ${i}: Found ${allPreviousImages.length} images but none have valid data URLs`);
                        }
                    }
                }
            }
            
            if (imagesToSend.length === 0) {
                console.log(`🚨 CRITICAL: No valid images found in any previous messages!`);
                console.log(`📊 Message summary:`, messages.map((msg, i) => ({
                    index: i,
                    type: msg.type,
                    hasImages: !!(msg.images && msg.images.length > 0),
                    hasHiddenImages: !!(msg.hiddenImages && msg.hiddenImages.length > 0)
                })));
            }
        }

        // Create message with text and images (for display only)
        const messageContent = {
            text: messageToSend,
            images: uploadedImages.map(img => ({
                url: img.url,
                name: img.name,
                file: img.file
            }))
        };

        const userMessage = useHomepageState ? {
            role: 'user',
            text: messageToSend,
            images: uploadedImages.length > 0 ? uploadedImages : [],
            hiddenImages: imagesToSend.length > 0 && uploadedImages.length === 0 ? imagesToSend : [],
            isTourMessage: isTourMode // Mark as tour message if in tour mode
        } : { 
            type: 'user', 
            content: messageToSend,
            images: uploadedImages.length > 0 ? uploadedImages : [],
            hiddenImages: imagesToSend.length > 0 && uploadedImages.length === 0 ? imagesToSend : []
        };
        
        // Only add user message to display if not skipped (for Daily Digest / Account Setup)
        if (!window._skipNextUserMessage) {
            setMessages(prev => [...prev, userMessage]);
        } else {
            // Clear the flag after using it
            window._skipNextUserMessage = false;
        }
        setUserInput('');
        setUploadedImages([]); // Clear uploaded images after sending
        setIsLoading(true);
        setIsCooldown(true); // Start cooldown period

        // Call onMessageSent callback to trigger maximize chat (if on homepage)
        if (onMessageSent) {
            onMessageSent();
        }
        
        // Show thinking indicator on homepage (skip if digest/setup already added it)
        if (useHomepageState && !window._skipNextUserMessage) {
            setIsThinking(true);
            
            // Safety timeout: Clear thinking state after 30 seconds if no response
            const safetyTimeout = setTimeout(() => {
                console.warn('⚠️ Safety timeout triggered - clearing stuck thinking state');
                setIsThinking(false);
                setTypingBuffer('');
                setIsTypingState(false);
                setIsLoading(false);
                setIsCooldown(false);
                cancelTyping();
            }, 30000); // 30 second timeout
            
            // Store timeout for cleanup
            typingTimeoutsRef.current.push(safetyTimeout);
        }

        // Add thinking message (skip on homepage as we use typewriter, skip if digest/setup already added it)
        if (!useHomepageState && !window._skipNextUserMessage) {
        const thinkingMessage = {
            type: 'assistant',
            content: 'Thinking',
            isThinking: true
        };
        setMessages(prev => [...prev, thinkingMessage]);
        }

        // Only expand chat modal on non-homepage pages
        if (!isChatExpanded && !useHomepageState) {
            handleExpandChat();
        }

        try {
            // Build context-aware conversation history for tour mode
            let conversationHistoryWithContext = messages;
            if (isTourMode) {
                // Add system message to let AI know it's in tour mode
                const tourContextMessage = {
                    role: 'system',
                    text: `You are a helpful tour guide for DIZEE, a platform for artists to manage their music career. You're currently in TOUR MODE on the general homepage, helping a user explore the platform. Be friendly, concise, and helpful. Keep responses brief (2-3 sentences). You can guide them to different sections: Bookings, Catalog, Knowledge Base, and Workflows.`
                };
                conversationHistoryWithContext = [tourContextMessage, ...messages];
            }
            
            const result = await processQuestionForDizee(messageToSend, conversationHistoryWithContext, dispatch, currentConversationId, imagesToSend);

            if (result.success) {
                // 🔒 SESSION VALIDATION: Check if this response is for the current active session using ref
                const currentActiveSession = activeChatSessionRef.current;
                console.log('🔒 Regular chat session validation check:', {
                    currentSession: currentActiveSession,
                    responseSession: sessionId,
                    matches: currentActiveSession === sessionId
                });
                
                // Only block if there's a DIFFERENT active session (not null)
                if (currentActiveSession && currentActiveSession !== sessionId) {
                    console.log('🚫 Ignoring stale response from different session:', {
                        responseSession: sessionId,
                        currentActiveSession: currentActiveSession,
                        response: result.response?.substring(0, 100)
                    });
                    
                    // Clean up UI state for this stale session before returning
                    if (useHomepageState) {
                        setIsThinking(false);
                        setTypingBuffer('');
                        setIsTypingState(false);
                        cancelTyping();
                    }
                    setIsLoading(false);
                    setIsCooldown(false);
                    
                    return;
                }
                
                console.log(`📝 FRONTEND UI: Processing successful result for session:`, sessionId);
                console.log(`📝 FRONTEND UI: Result response:`, result.response?.substring(0, 200));
                
                // Check for fake data in the result before displaying
                if (result.response && (result.response.includes('The Weeknd') || result.response.includes('Show Schedule'))) {
                    console.log(`🚨🚨🚨 FRONTEND UI: FAKE DATA DETECTED IN RESULT! 🚨🚨🚨`);
                    console.log(`🚨 FRONTEND UI: About to display fake data to user!`);
                    console.log(`🚨 FRONTEND UI: Full result.response:`, result.response);
                }
                
                // CURSOR-STYLE: Update the user message with processed images (base64 URLs)
                console.log(`🔍 Processing result:`, {
                    hasProcessedImages: !!(result.processedImages && result.processedImages.length > 0),
                    processedImagesCount: result.processedImages?.length || 0,
                    uploadedImagesCount: uploadedImages.length,
                    imagesToSendCount: imagesToSend.length,
                    processedImageTypes: result.processedImages?.map(img => ({
                        name: img.name,
                        urlType: img.url?.startsWith('data:image/') ? 'VALID-data-url' : 'INVALID',
                        urlPreview: img.url?.substring(0, 60) + '...'
                    }))
                });
                
                if (result.processedImages && result.processedImages.length > 0) {
                    // Always update the user message with processed base64 images
                    setMessages(prev => {
                        const updated = [...prev];
                        // Find the user message we just added
                        // On homepage: last message (no thinking message added)
                        // On other pages: second to last (thinking message was added last)
                        const userMessageIndex = useHomepageState ? updated.length - 1 : updated.length - 2;
                        const messageType = useHomepageState ? 'user' : 'user';
                        const roleKey = useHomepageState ? 'role' : 'type';
                        
                        if (updated[userMessageIndex] && updated[userMessageIndex][roleKey] === messageType) {
                            console.log(`🔄 Updating user message at index ${userMessageIndex} with processed images`);
                            
                            const updatedMessage = {
                                ...updated[userMessageIndex],
                                images: uploadedImages.length > 0 ? result.processedImages : updated[userMessageIndex].images,
                                hiddenImages: uploadedImages.length === 0 ? result.processedImages : (updated[userMessageIndex].hiddenImages || [])
                            };
                            
                            console.log(`📝 Updated message will have:`, {
                                visibleImages: updatedMessage.images?.length || 0,
                                hiddenImages: updatedMessage.hiddenImages?.length || 0,
                                visibleImageTypes: updatedMessage.images?.map(img => img.url?.startsWith('data:image/') ? 'VALID' : 'INVALID'),
                                hiddenImageTypes: updatedMessage.hiddenImages?.map(img => img.url?.startsWith('data:image/') ? 'VALID' : 'INVALID')
                            });
                            
                            updated[userMessageIndex] = updatedMessage;
                        }
                        return updated;
                    });
                    console.log(`✅ CURSOR-STYLE: Updated user message with ${result.processedImages.length} processed images`);
                }
                
                setConversationHistory(result.conversation);
                
                // Remove thinking message first
                setMessages(prev => {
                    const updated = [...prev];
                    const lastIndex = updated.length - 1;
                    if (updated[lastIndex] && updated[lastIndex].isThinking) {
                        updated.splice(lastIndex, 1); // Remove thinking message
                    }
                    return updated;
                });
                
                // Use typewriter effect on homepage, instant on other pages
                if (useHomepageState) {
                    // Homepage: typewriter effect
                    // Remove form markers before displaying during typing
                    const cleanResponse = result.response
                        .replace(/^\[CATALOG_FORM:(release|demo)\]\s*/g, '')
                        .replace(/^\[BOOKING_FORM:show\]\s*/g, '')
                        .replace(/^\[CONFIRM_SHOWS:list\]\s*/g, '')
                        .replace(/^\[TOURING_FLIGHTS:navigate\]\s*/g, '')
                        .replace(/^\[TOURING_HOTELS:navigate\]\s*/g, '')
                        .replace(/^\[TOURING_TRANSPORT:navigate\]\s*/g, '')
                        .replace(/^\[ADD_TICKET_COUNTS:form\]\s*/g, '')
                        .trim();
                    const originalResponse = result.response; // Keep original with marker for form detection
                    console.log('🎬 Starting typewriter effect for response:', cleanResponse?.substring(0, 50));
                    console.log('🔍 Current messages before typewriter:', messages.length);
                    typewriterEffect(cleanResponse, (finalText) => {
                        console.log('✅ Typewriter callback invoked, adding message to state');
                        console.log('📊 Final text to add:', finalText?.substring(0, 100));
                        
                        setMessages(prev => {
                            console.log('🔍 Previous messages in updater:', prev.length);
                            // Check if this message was already added (e.g., user sent another message while typing)
                            const lastMsg = prev[prev.length - 1];
                            if (lastMsg && lastMsg.role === 'assistant' && (lastMsg.text === finalText || lastMsg.text === originalResponse)) {
                                console.log('⚠️ Duplicate message detected, skipping');
                                return prev; // Message already exists, don't add again
                            }
                            console.log('📝 Adding assistant message to chat');
                            
                            // Format message for tour mode
                            // Store ORIGINAL response with marker so form detection works
                            const assistantMessage = {
                                role: 'assistant',
                                text: originalResponse
                            };
                            
                            // If in tour mode, add tour-specific properties
                            if (isTourMode) {
                                assistantMessage.isTourMessage = true;
                                assistantMessage.showOptions = true;
                                assistantMessage.options = ['menu'];
                            }
                            
                            const newMessages = [...prev, assistantMessage];
                            console.log('✅ New messages array length:', newMessages.length);
                            return newMessages;
                        });
                        
                        // Force a small delay to ensure state update completes
                        setTimeout(() => {
                            console.log('🔍 Messages after callback:', messages.length);
                        }, 100);
                    });
                    } else {
                    // Other pages: instant response
                    setMessages(prev => [...prev, {
                            type: 'assistant',
                            content: result.response,
                    }]);
                    }
                setId(result.conversationId);

                // 🔧 CRITICAL: Dispatch conversation ID events IMMEDIATELY (before typewriter finishes)
                // This ensures the landing page receives the ID before form submission
                if (isNewChat && result.conversationId) {
                    setChatMode('continuing');
                    setLoadedConversationId(result.conversationId);
                    console.log('🆕 New conversation created, switching to CONTINUING mode');
                    
                    // Store in localStorage as fallback
                    localStorage.setItem('currentAIConversationId', result.conversationId);
                    console.log('💾 Stored conversation ID in localStorage:', result.conversationId);
                    
                    // Dispatch IMMEDIATELY
                    window.dispatchEvent(new CustomEvent('newConversationCreated', {
                        detail: { conversationId: result.conversationId }
                    }));
                    console.log('✅ newConversationCreated event dispatched IMMEDIATELY:', result.conversationId);
                } else if (result.conversationId) {
                    // Already in continuing mode, just update
                    console.log('🔄 Conversation continued');
                    
                    // Store/update in localStorage as fallback
                    localStorage.setItem('currentAIConversationId', result.conversationId);
                    console.log('💾 Updated conversation ID in localStorage:', result.conversationId);
                    
                    // Dispatch IMMEDIATELY
                    window.dispatchEvent(new CustomEvent('conversationUpdated', {
                        detail: { conversationId: result.conversationId }
                    }));
                    console.log('✅ conversationUpdated event dispatched IMMEDIATELY:', result.conversationId);
                } else {
                    console.log('⚠️ No conversation ID returned:', {
                        hasConversationId: !!result.conversationId,
                        isNewChat,
                        chatMode
                    });
                }

                // Handle AI actions feedback
                if (result.actions_taken && result.actions_taken.length > 0) {
                    setAiActions(result.actions_taken);
                    setShowActionFeedback(true);
                    
                    // Auto-hide feedback after 5 seconds
                    setTimeout(() => {
                        setShowActionFeedback(false);
                    }, 5000);
                }
            } else {
                    // Clear thinking state on homepage
                    if (useHomepageState) {
                        setIsThinking(false);
                        setTypingBuffer('');
                        setIsTypingState(false);
                    }
                    
                    // Replace thinking message with error message
                    setMessages(prev => {
                        const updated = [...prev];
                        const lastIndex = updated.length - 1;
                        if (updated[lastIndex] && updated[lastIndex].isThinking) {
                            updated[lastIndex] = {
                                type: 'assistant',
                                content: "I'm sorry, I encountered an issue processing your request. Please try again.",
                            };
                        } else {
                            updated.push({
                                type: 'assistant',
                                content: "I'm sorry, I encountered an issue processing your request. Please try again.",
                            });
                        }
                        return updated;
                    });
                console.error("Error from AI service:", result.error);
            }
        } catch (error) {
            // 🔒 SESSION VALIDATION: Check if this error is for the current active session using ref
            const currentActiveSession = activeChatSessionRef.current;
            console.log('🔒 Regular chat error session validation check:', {
                currentSession: currentActiveSession,
                errorSession: sessionId,
                matches: currentActiveSession === sessionId,
                error: error.message
            });
            
            // Only block if there's a DIFFERENT active session (not null)
            if (currentActiveSession && currentActiveSession !== sessionId) {
                console.log('🚫 Ignoring error from different session:', {
                    errorSession: sessionId,
                    currentActiveSession: currentActiveSession,
                    error: error.message
                });
                
                // Clean up UI state for this stale session before returning
                if (useHomepageState) {
                    setIsThinking(false);
                    setTypingBuffer('');
                    setIsTypingState(false);
                    cancelTyping();
                }
                setIsLoading(false);
                setIsCooldown(false);
                
                return;
            }
            
            console.error("Error in handleSendMessage:", error);
            
            // Clear thinking state on homepage
            if (useHomepageState) {
                setIsThinking(false);
                setTypingBuffer('');
                setIsTypingState(false);
            }
            
            setMessages(prev => [...prev, {
                type: 'assistant',
                content: "I apologize, but there was an error. Please try again later.",
            }]);
        } finally {
            // Don't clear thinking state on homepage - let typewriter effect handle it
            // For non-homepage, thinking is already cleared by message replacement
            
            // 🔒 CONTAMINATION PREVENTION: Minimum loading duration to prevent rapid interactions
            // Shorter delay now that messages are added to array immediately
            const loadingDelay = useHomepageState ? 1500 : 1500;
            setTimeout(() => {
                setIsLoading(false);
                setIsCooldown(false); // Clear cooldown period
            }, loadingDelay);
        }
    };

    const handleInputFocus = () => {
        // Don't auto-expand on focus, only expand when message is sent
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSendMessage();
        }
    };

    const handleFileUpload = () => {
        console.log('File upload triggered');
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        
        if (files.length > 0) {
            // Create preview URLs for all files
            const filePreviewUrls = files.map(file => {
                let previewUrl = null;
                let isSupported = false;
                let rejectReason = null;
                
                // Check file size limits
                const maxImageSize = 10 * 1024 * 1024; // 10MB for images
                const maxTextSize = 5 * 1024 * 1024;   // 5MB for text files
                const maxPDFSize = 25 * 1024 * 1024;   // 25MB for PDFs
                
                // Create preview for images
                if (file.type.startsWith('image/')) {
                    if (file.size <= maxImageSize) {
                        previewUrl = URL.createObjectURL(file);
                        isSupported = true;
                    } else {
                        rejectReason = 'Image too large (max 10MB)';
                    }
                }
                // Check for PDF files
                else if (file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')) {
                    if (file.size <= maxPDFSize) {
                        isSupported = true;
                    } else {
                        rejectReason = 'PDF too large (max 25MB)';
                    }
                }
                // Check for supported text files (CSV, TXT, JSON, etc.)
                else if (file.type === 'text/csv' || 
                         file.type.startsWith('text/') || 
                         file.name.toLowerCase().match(/\.(csv|txt|json|xml|md)$/)) {
                    if (file.size <= maxTextSize) {
                        isSupported = true;
                    } else {
                        rejectReason = 'File too large (max 5MB)';
                    }
                }
                else {
                    rejectReason = 'Unsupported file type';
                }
                
                return {
                    file,
                    url: previewUrl,
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    isSupported,
                    rejectReason
                };
            });
            
            // Filter out unsupported files and show warning if any
            const supportedFiles = filePreviewUrls.filter(file => file.isSupported);
            const unsupportedFiles = filePreviewUrls.filter(file => !file.isSupported);
            
            console.log('Files processed:', supportedFiles.length, 'supported,', unsupportedFiles.length, 'rejected');
            
            if (unsupportedFiles.length > 0) {
                console.warn('Unsupported files filtered out:', unsupportedFiles.map(f => `${f.name}: ${f.rejectReason}`));
                // Show a temporary message to user
                const reasons = unsupportedFiles.map(f => `${f.name}: ${f.rejectReason}`).join('\n');
                const message = `${unsupportedFiles.length} file(s) were filtered out:\n${reasons}`;
                setMessages(prev => [...prev, {
                    type: 'assistant',
                    content: message,
                }]);
            }
            
            setUploadedImages(prev => [...prev, ...supportedFiles]);
            
            // Don't auto-expand chat when files are uploaded - let user decide when to send
        }
        
        // Reset file input
        event.target.value = '';
    };

    const removeImage = (index) => {
        setUploadedImages(prev => {
            const newImages = [...prev];
            URL.revokeObjectURL(newImages[index].url); // Clean up memory
            newImages.splice(index, 1);
            return newImages;
        });
    };

    // Preprocess AI response for better formatting
    const preprocessAIResponse = (text) => {
        if (!text) return text;
        
        console.log('🔍 RAW RESPONSE:', text.substring(0, 300) + '...');
        
        // Moderate preprocessing for better spacing (less aggressive)
        let processed = text
            // Add single line break before bullet points if missing
            .replace(/([.!?])\s*([•\-*])/g, '$1\n$2')
            // Add spacing around section headers (words ending with :)
            .replace(/([A-Z][^:\n]*:)(?!\s*\n)/g, '$1\n')
            // Add spacing only after major introductory phrases
            .replace(/(Here are the details|Here are|These include)([^:\n]*:)/gi, '\n$1$2\n')
            // Fix spacing around bullet points (single line break)
            .replace(/([^\n])\s*([•\-*]\s)/g, '$1\n$2')
            // Clean up excessive line breaks
            .replace(/\n{3,}/g, '\n\n')
            // Ensure proper spacing after colons (single line break)
            .replace(/:(?!\s*\n)(?=\s*[A-Za-z])/g, ':\n')
            .trim();
            
        console.log('🔍 PREPROCESSED:', processed.substring(0, 300) + '...');
        
        return processed;
    };

    // Format AI responses for better readability with proper markdown rendering
    const formatAIResponse = (text, message = null) => {
        if (!text) return text;
        
        // Clean navigation commands from display (used for onboarding agent navigation)
        const cleanedText = cleanNavigationCommands(text);
        
        console.log('🎯 FORMATTING INPUT:', cleanedText.substring(0, 200) + '...');
        
        // First apply aggressive preprocessing
        const preprocessed = preprocessAIResponse(cleanedText);
        
        // Check if this is a tour message that should show options inline
        const shouldShowInlineOptions = message && message.isTourMessage && message.showOptions;
        
        console.log('🎯 formatAIResponse called with message:', {
            isTourMessage: message?.isTourMessage,
            showOptions: message?.showOptions,
            options: message?.options,
            shouldShowInline: shouldShowInlineOptions
        });
        
        // Check if this looks like extracted data from an image (tables, lists, show data)
        let formatted = preprocessed;
        if (text.includes('|') || text.includes('Performance Date') || text.includes('Total Entries:') || 
            text.includes('TOTAL ROWS FOUND:') || text.includes('Show') || text.includes('Date:')) {
            try {
                formatted = imageDataFormatter.autoFormat(preprocessed);
            } catch (error) {
                console.log('Image data formatting failed, using basic formatting:', error);
                // Fall back to basic formatting
            }
        }
        
        // Apply basic formatting improvements
        formatted = formatted
            .replace(/•/g, '•')  // Ensure bullet points are consistent
            .replace(/- /g, '• ') // Convert dashes to bullets
            .replace(/\* /g, '• ') // Convert asterisks to bullets
            .trim();
        
        // Join lines that should be together (like "• Label:" followed by a number)
        const rawLines = formatted.split('\n');
        const joinedLines = [];
        
        for (let i = 0; i < rawLines.length; i++) {
            const currentLine = rawLines[i].trim();
            const nextLine = rawLines[i + 1]?.trim();
            
            // If current line ends with ":" and next line is just a number, join them
            if (currentLine.endsWith(':') && nextLine && /^\d+$/.test(nextLine)) {
                joinedLines.push(`${currentLine} ${nextLine}`);
                i++; // Skip the next line since we've joined it
            } else {
                joinedLines.push(rawLines[i]);
            }
        }
        
        // Split text into parts and handle markdown formatting
        const parts = [];
        const lines = joinedLines;
        
        lines.forEach((line, lineIndex) => {
            if (line.trim() === '') {
                parts.push(<br key={`br-${lineIndex}`} />);
                return;
            }
            
            // Handle bullet points with better styling
            if (line.trim().startsWith('•') || line.trim().startsWith('-') || line.trim().startsWith('*')) {
                const bulletContent = line.trim().replace(/^[•\-\*]\s*/, '');
                parts.push(
                    <div key={`bullet-${lineIndex}`} style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        margin: '6px 0',
                        paddingLeft: '4px'
                    }}>
                        <span style={{ 
                            color: '#FF2300', 
                            marginRight: '10px',
                            fontSize: '14px',
                            lineHeight: '1.5',
                            fontWeight: '600'
                        }}>•</span>
                        <span style={{ 
                            flex: 1, 
                            lineHeight: '1.5',
                            fontSize: '13px'
                        }}>{bulletContent}</span>
                    </div>
                );
                return;
            }
            
            // Check for markdown headers first
            const headerMatch = line.match(/^(#{1,6})\s+(.+)$/);
            if (headerMatch) {
                const level = headerMatch[1].length;
                const text = headerMatch[2];
                const HeaderTag = `h${Math.min(level, 6)}`;
                parts.push(
                    React.createElement(HeaderTag, {
                        key: `header-${lineIndex}`,
                        style: {
                            fontSize: level === 1 ? '16px' : level === 2 ? '14px' : '13px',
                            fontWeight: '600',
                            margin: '12px 0 8px 0',
                            color: '#ffffff'
                        }
                    }, text)
                );
                return;
            }
            
            // Process line for markdown formatting
            const processedLine = [];
            let currentIndex = 0;
            let partIndex = 0;
            
            // Handle **bold** formatting
            line.replace(/\*\*(.*?)\*\*/g, (match, content, index) => {
                // Add text before bold
                if (index > currentIndex) {
                    processedLine.push(line.substring(currentIndex, index));
                }
                // Add bold text
                processedLine.push(<strong key={`bold-${lineIndex}-${partIndex++}`}>{content}</strong>);
                currentIndex = index + match.length;
                return match;
            });
            
            // Handle *italic* formatting (but not **bold** which we already handled)
            const remainingText = line.substring(currentIndex);
            let tempIndex = currentIndex;
            
            remainingText.replace(/(?<!\*)\*(?!\*)([^*]+?)\*(?!\*)/g, (match, content, index) => {
                const actualIndex = tempIndex + index;
                // Add text before italic
                if (actualIndex > currentIndex) {
                    processedLine.push(line.substring(currentIndex, actualIndex));
                }
                // Add italic text
                processedLine.push(<em key={`italic-${lineIndex}-${partIndex++}`}>{content}</em>);
                currentIndex = actualIndex + match.length;
                return match;
            });
            
            // Add remaining text
            if (currentIndex < line.length) {
                processedLine.push(line.substring(currentIndex));
            }
            
            // If no formatting was found, just add the plain line
            if (processedLine.length === 0) {
                processedLine.push(line);
            }
            
            parts.push(<div key={`line-${lineIndex}`}>{processedLine}</div>);
        });
        
        // Add inline tour options if this is a tour message
        if (shouldShowInlineOptions && message.options) {
            parts.push(
                <div key="tour-options-inline" style={{ marginTop: '16px' }}>
                    <TourOptions 
                        options={message.options}
                        onOptionSelect={handleTourOptionSelect}
                    />
                </div>
            );
        }
        
        // Add inline tour preset questions if requested
        if (message && message.isTourMessage && message.showQuestions) {
            parts.push(
                <div key="tour-questions-inline" style={{ marginTop: '16px' }}>
                    <TourPresetQuestions 
                        onQuestionSelect={handleTourQuestionSelect}
                    />
                </div>
            );
        }
        
        const result = <div>{parts}</div>;
        console.log('🎯 FORMATTED OUTPUT: Processed', lines.length, 'lines');
        
        return result;
    };

    const handleExpertPromptClick = async (prompt) => {
        const userMessage = { type: 'user', content: prompt };
        setMessages(prev => [...prev, userMessage]);
        setIsLoading(true);

        if (!isChatExpanded) {
            handleExpandChat();
        }

        try {
            // For experts, we'll fetch from our curated expert responses
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000'}/api/v1/experts/response`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('dizeeToken')}`
                },
                body: JSON.stringify({ question: prompt })
            });

            if (response.ok) {
                const expertData = await response.json();
                setMessages(prev => [...prev, {
                    type: 'assistant',
                    content: expertData.data.answer,
                    isExpert: true,
                    sources: expertData.data.sources,
                    followUpQuestions: expertData.data.followUpQuestions
                }]);
            } else {
                setMessages(prev => [...prev, {
                    type: 'assistant',
                    content: "I'm sorry, I couldn't find an expert response for that question. Please try another prompt.",
                }]);
            }
        } catch (error) {
            setMessages(prev => [...prev, {
                type: 'assistant',
                content: "I'm sorry, I encountered an issue retrieving the expert response. Please try again.",
            }]);
            console.error("Error in handleExpertPromptClick:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleFlowPromptClick = async (prompt) => {
        // Handle "Add Quick Reminder" prompt
        if (prompt === "Add Quick Reminder") {
            navigate('/flows/quick-add');
            return;
        }

        // Handle "Create Workflow" prompt
        if (prompt === "Create Workflow") {
            navigate('/flows/create-workflow');
            return;
        }

        // Handle workflow-specific prompts (ending with " flow")
        if (prompt.endsWith(' flow')) {
            const workflowName = prompt.replace(' flow', '');
            const workflows = getUserWorkflows();
            const workflow = workflows.find(w => w.name === workflowName);

            if (!workflow) {
                console.error('Workflow not found:', workflowName);
                return;
            }

            // Add user message
            const userMessage = { type: 'user', content: prompt };
            setMessages(prev => [...prev, userMessage]);

            if (!isChatExpanded) {
                handleExpandChat();
            }

            // Get all reminders for this workflow
            const reminders = JSON.parse(localStorage.getItem('userReminders') || '[]');
            const workflowSteps = reminders
                .filter(r => r.releaseId === workflow.id)
                .sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate));

            // Format workflow steps
            let stepsText = `**${workflow.name}** (${workflow.type === 'show' ? 'Show' : 'Song Release'} Workflow)\n\n`;
            stepsText += `**${workflowSteps.length} steps:**\n\n`;
            
            workflowSteps.forEach((step, index) => {
                const status = step.status === 'completed' ? '✓' : '○';
                const dueDate = new Date(step.dueDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
                stepsText += `${status} ${index + 1}. ${step.title} (${dueDate})\n`;
            });

            stepsText += `\n[View in Workflows App](/flows/workflow/${workflow.id})`;

            // Add assistant response with workflow steps
            const assistantMessage = {
                type: 'assistant',
                content: stepsText,
                isFlowMessage: true,
                workflowId: workflow.id
            };

            setMessages(prev => [...prev, assistantMessage]);
            return;
        }

        // Default: let AI handle the prompt
        const userMessage = { type: 'user', content: prompt };
        setMessages(prev => [...prev, userMessage]);
        setIsLoading(true);

        if (!isChatExpanded) {
            handleExpandChat();
        }

        // Process through AI
        try {
            const currentConversationId = loadedConversationId || conversationId;
            const result = await processQuestionForDizee(prompt, messages, dispatch, currentConversationId, uploadedImages);
            
            if (result.success) {
                console.log('Flow prompt processed by AI');
            }
        } catch (error) {
            console.error('Error processing flow prompt:', error);
        } finally {
            setIsLoading(false);
        }
    };

    // Form handling removed - AI handles catalog creation conversationally

    const handleCatalogFormSubmit = async () => {
        console.log('📝 Submitting catalog form:', catalogFormData);
        
        // Validate required fields
        if (!catalogFormData.songTitle.trim()) {
            alert('Song title is required');
            return;
        }
        
        const validPrimaryArtists = catalogFormData.primaryArtists?.filter(artist => artist && artist.trim() !== '') || [];
        if (validPrimaryArtists.length === 0) {
            alert('At least one primary artist is required');
            return;
        }
        
        // Remove the form message from chat and add user confirmation
        const primaryArtistsText = validPrimaryArtists.join(', ');
        const validFeaturedArtists = catalogFormData.featuredArtists?.filter(artist => artist && artist.trim() !== '') || [];
        const featuredArtistsText = validFeaturedArtists.length > 0 ? validFeaturedArtists.join(', ') : '';
        
        const confirmationMessage = { 
            type: 'user', 
            content: `Song: "${catalogFormData.songTitle}" by ${primaryArtistsText}${featuredArtistsText ? ` (feat. ${featuredArtistsText})` : ''}` 
        };
        
        // Replace the form message with confirmation and add thinking
        setMessages(prev => {
            const withoutForm = prev.filter(msg => !msg.isForm);
            return [
                ...withoutForm,
                confirmationMessage,
                { type: 'assistant', content: 'Adding to catalog...', isThinking: true }
            ];
        });
        
        setIsLoading(true);

        try {
            // Create the prompt that will trigger the AI to use create_catalog_item function
            const catalogPrompt = `Please add this ${catalogFormType === 'release' ? 'upcoming release' : 'demo'} to my catalog:

Song Title: ${catalogFormData.songTitle}
Primary Artist: ${primaryArtistsText}
${featuredArtistsText ? `Featured Artists: ${featuredArtistsText}` : ''}
Release Status: ${catalogFormData.releaseStatus}
${catalogFormData.releaseDate ? `Release Date: ${catalogFormData.releaseDate}` : ''}
${catalogFormData.additionalInfo ? `Additional Info: ${catalogFormData.additionalInfo}` : ''}

Please create this catalog item now.`;

            const currentConversationId = loadedConversationId || conversationId;
            
            // Get messages without the thinking message for the API call
            const messagesForAPI = messages.filter(msg => !msg.isThinking && !msg.isForm);
            
            const result = await processQuestionForDizee(catalogPrompt, messagesForAPI, dispatch, currentConversationId, []);
            
            if (result.success) {
                console.log('✅ Catalog item added successfully');
                
                // Remove thinking message and add success response
                setMessages(prev => {
                    const withoutThinking = prev.filter(msg => !msg.isThinking);
                    return [
                        ...withoutThinking,
                        { type: 'assistant', content: result.response }
                    ];
                });
                
                // Reset form data
                setCatalogFormData({
                    songTitle: '',
                    primaryArtists: [''],
                    featuredArtists: [''],
                    releaseStatus: 'upcoming',
                    releaseDate: '',
                    additionalInfo: ''
                });
            }
        } catch (error) {
            console.error('❌ Error adding catalog item:', error);
            
            // Remove thinking message and add error response
            setMessages(prev => {
                const withoutThinking = prev.filter(msg => !msg.isThinking);
                return [
                    ...withoutThinking,
                    { type: 'assistant', content: 'Sorry, there was an error adding the catalog item. Please try again.' }
                ];
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleCatalogFormCancel = () => {
        // Remove the form message from chat
        setMessages(prev => prev.filter(msg => !msg.isForm));
        
        setCatalogFormData({
            songTitle: '',
            primaryArtists: [''],
            featuredArtists: [''],
            releaseStatus: 'upcoming',
            releaseDate: '',
            additionalInfo: ''
        });
    };

    // Primary artist management functions
    const addPrimaryArtist = () => {
        if (catalogFormData.primaryArtists.length < 6) {
            setCatalogFormData(prev => ({
                ...prev,
                primaryArtists: [...prev.primaryArtists, '']
            }));
        }
    };

    const removePrimaryArtist = (index) => {
        if (catalogFormData.primaryArtists.length > 1) {
            setCatalogFormData(prev => ({
                ...prev,
                primaryArtists: prev.primaryArtists.filter((_, i) => i !== index)
            }));
        }
    };

    const updatePrimaryArtist = (index, value) => {
        setCatalogFormData(prev => ({
            ...prev,
            primaryArtists: prev.primaryArtists.map((artist, i) => i === index ? value : artist)
        }));
    };

    // Featured artist management functions
    const addFeaturedArtist = () => {
        if (catalogFormData.featuredArtists.length < 6) {
            setCatalogFormData(prev => ({
                ...prev,
                featuredArtists: [...prev.featuredArtists, '']
            }));
        }
    };

    const removeFeaturedArtist = (index) => {
        if (catalogFormData.featuredArtists.length > 1) {
            setCatalogFormData(prev => ({
                ...prev,
                featuredArtists: prev.featuredArtists.filter((_, i) => i !== index)
            }));
        }
    };

    const updateFeaturedArtist = (index, value) => {
        setCatalogFormData(prev => ({
            ...prev,
            featuredArtists: prev.featuredArtists.map((artist, i) => i === index ? value : artist)
        }));
    };

    const handlePresetPromptClick = async (prompt) => {
        // Check if this is the "Restart Tutorial" prompt
        if (prompt === "Restart Tutorial") {
            // Clear all walkthrough and tutorial flags
            localStorage.removeItem('dizeeWalkthroughCompleted');
            localStorage.removeItem('hasSeenWalkthrough');
            localStorage.removeItem('hasSeenTutorial');
            localStorage.removeItem('onboardingCompletedDate');
            localStorage.removeItem('dailyDigestLastShown');
            localStorage.removeItem('accountSetupCompleted');
            
            // Set flag to trigger walkthrough on next landing page visit
            localStorage.setItem('isNewSignup', 'true');
            
            // Check if we're already on the landing page
            if (window.location.pathname === '/') {
                // Force a page reload to restart the tutorial
                window.location.reload();
            } else {
                // Navigate to landing page to start walkthrough
                navigate('/');
            }
            return;
        }

        // Check if we're in flows mode
        if (activeNavItem === 'flows') {
            return handleFlowPromptClick(prompt);
        }

        // Check if we're in experts mode
        if (activeNavItem === 'experts') {
            return handleExpertPromptClick(prompt);
        }

        // Let AI handle all prompts conversationally - no special form handling needed

        // Clear any existing typing state before starting new message
        if (useHomepageState) {
            // If currently typing, immediately finalize the typing buffer as a complete message
            if (typingBuffer && typingBuffer.length > 0) {
                setMessages(prev => {
                    // Only add if not already in the array
                    const exists = prev.some(m => m.role === 'assistant' && m.text === typingBuffer);
                    if (exists) return prev;
                    return [...prev, { role: 'assistant', text: typingBuffer }];
                });
            }
            setTypingBuffer('');
            setIsTypingState(false);
        }

        // 🔒 SESSION TRACKING: Generate unique session ID to prevent contamination
        const sessionId = `preset_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        activeChatSessionRef.current = sessionId;
        setActiveChatSession(sessionId);
        console.log('🎯 PRESET PROMPT - Starting session:', { prompt, sessionId });

        // Expand chat only on non-homepage pages
        if (!useHomepageState && !isChatExpanded) {
            handleExpandChat();
        }

        // Format message based on homepage state
        const userMessage = useHomepageState 
            ? { role: 'user', text: prompt, isTourMessage: isTourMode } // Mark as tour message if in tour mode
            : { type: 'user', content: prompt };
        
        // Add user message to existing conversation (just like typing)
        setMessages(prev => [...prev, userMessage]);
        setUserInput('');
        setIsLoading(true);
        setIsCooldown(true);
        
        // Call onMessageSent callback to trigger maximize chat (if on homepage)
        if (onMessageSent) {
            onMessageSent();
        }
        
        // Show thinking indicator on homepage
        if (useHomepageState) {
            setIsThinking(true);
        } else {
            // Add thinking message for non-homepage
        const thinkingMessage = { type: 'assistant', content: 'Thinking', isThinking: true };
            setMessages(prev => [...prev, thinkingMessage]);
        }

        try {
            // Use existing conversation context (just like typing a message)
            const currentConversationId = loadedConversationId || conversationId;
            
            // Build context-aware conversation history for tour mode
            let conversationHistoryWithContext = messages;
            if (isTourMode) {
                // Add system message to let AI know it's in tour mode
                const tourContextMessage = {
                    role: 'system',
                    text: `You are a helpful tour guide for DIZEE, a platform for artists to manage their music career. You're currently in TOUR MODE on the general homepage, helping a user explore the platform. Be friendly, concise, and helpful. Keep responses brief (2-3 sentences). You can guide them to different sections: Bookings, Catalog, Knowledge Base, and Workflows.`
                };
                conversationHistoryWithContext = [tourContextMessage, ...messages];
            }
            
            const result = await processQuestionForDizee(prompt, conversationHistoryWithContext, dispatch, currentConversationId, uploadedImages);
            
            if (result.success) {
                // 🔒 SESSION VALIDATION: Check if this response is for the current active session using ref
                const currentActiveSession = activeChatSessionRef.current;
                console.log('🔒 Session validation check:', {
                    currentSession: currentActiveSession,
                    responseSession: sessionId,
                    matches: currentActiveSession === sessionId
                });
                
                // Only block if there's a DIFFERENT active session (not null)
                if (currentActiveSession && currentActiveSession !== sessionId) {
                    console.log('🚫 Ignoring stale preset response from different session:', {
                        responseSession: sessionId,
                        currentActiveSession: currentActiveSession,
                        prompt: prompt.substring(0, 50)
                    });
                    
                    // Clean up UI state for this stale session before returning
                    if (useHomepageState) {
                        setIsThinking(false);
                        setTypingBuffer('');
                        setIsTypingState(false);
                        cancelTyping();
                    }
                    setIsLoading(false);
                    setIsCooldown(false);
                    
                    return;
                }
                
                // Set new conversation state
                setConversationHistory(result.conversation);
                setId(result.conversationId);
                setLoadedConversationId(result.conversationId);
                setChatMode('continuing');
                
                // Handle response based on homepage state
                if (useHomepageState) {
                    // Homepage: use typewriter effect
                    // Remove form markers before displaying during typing
                    const cleanResponse = result.response
                        .replace(/^\[CATALOG_FORM:(release|demo)\]\s*/g, '')
                        .replace(/^\[BOOKING_FORM:show\]\s*/g, '')
                        .replace(/^\[CONFIRM_SHOWS:list\]\s*/g, '')
                        .replace(/^\[TOURING_FLIGHTS:navigate\]\s*/g, '')
                        .replace(/^\[TOURING_HOTELS:navigate\]\s*/g, '')
                        .replace(/^\[TOURING_TRANSPORT:navigate\]\s*/g, '')
                        .replace(/^\[ADD_TICKET_COUNTS:form\]\s*/g, '')
                        .trim();
                    const originalResponse = result.response; // Keep original with marker for form detection
                    typewriterEffect(cleanResponse, (finalText) => {
                        setMessages(prev => {
                            // Check if this message was already added (e.g., user sent another message while typing)
                            const lastMsg = prev[prev.length - 1];
                            if (lastMsg && lastMsg.role === 'assistant' && (lastMsg.text === finalText || lastMsg.text === originalResponse)) {
                                return prev; // Message already exists, don't add again
                            }
                            
                            // Format message for tour mode
                            // Store ORIGINAL response with marker so form detection works
                            const assistantMessage = {
                                role: 'assistant',
                                text: originalResponse
                            };
                            
                            // If in tour mode, add tour-specific properties
                            if (isTourMode) {
                                assistantMessage.isTourMessage = true;
                                assistantMessage.showOptions = true;
                                assistantMessage.options = ['menu'];
                            }
                            
                            return [...prev, assistantMessage];
                        });
                    });
                } else {
                    // Non-homepage: instant response, remove thinking message first
                    setMessages(prev => {
                        const updated = [...prev];
                        const lastIndex = updated.length - 1;
                        if (updated[lastIndex] && updated[lastIndex].isThinking) {
                            updated.splice(lastIndex, 1); // Remove thinking message
                        }
                        return [...updated, { type: 'assistant', content: result.response }];
                    });
                }
                
                console.log('✅ Preset prompt success - Clean conversation:', result.conversationId);
            } else {
                // Clear thinking state on homepage on error
                if (useHomepageState) {
                    setIsThinking(false);
                    setTypingBuffer('');
                    setIsTypingState(false);
                }
                
                const errorMessage = useHomepageState
                    ? { role: 'assistant', text: "I'm sorry, I encountered an issue. Please try again." }
                    : { type: 'assistant', content: "I'm sorry, I encountered an issue. Please try again." };
                setMessages(prev => [...prev, errorMessage]);
            }
        } catch (error) {
            // 🔒 SESSION VALIDATION: Only ignore errors from different sessions (not null) using ref
            const currentActiveSession = activeChatSessionRef.current;
            if (currentActiveSession && currentActiveSession !== sessionId) {
                console.log('🚫 Ignoring preset error from different session:', {
                    errorSession: sessionId,
                    currentActiveSession: currentActiveSession,
                    prompt: prompt.substring(0, 50)
                });
                
                // Clean up UI state for this stale session before returning
                if (useHomepageState) {
                    setIsThinking(false);
                    setTypingBuffer('');
                    setIsTypingState(false);
                    cancelTyping();
                }
                setIsLoading(false);
                setIsCooldown(false);
                
                return;
            }
            
            console.error("Preset prompt error:", error);
            
            // Clear thinking state on homepage on error
            if (useHomepageState) {
                setIsThinking(false);
                setTypingBuffer('');
                setIsTypingState(false);
            }
            
            const errorMessage = useHomepageState
                ? { role: 'assistant', text: "I apologize, there was an error. Please try again." }
                : { type: 'assistant', content: "I apologize, there was an error. Please try again." };
            setMessages(prev => [...prev, errorMessage]);
        } finally {
            // Don't clear thinking state on homepage - let typewriter effect handle it
            // Shorter delay now that messages are added to array immediately
            const loadingDelay = useHomepageState ? 1500 : 1500;
            setTimeout(() => {
            setIsLoading(false);
                setIsCooldown(false);
            }, loadingDelay);
        }
    };

    // Combine preset prompts with enabled custom prompts based on active nav
    const allPrompts = activeNavItem === 'experts' 
        ? getCurrentPrompts() // Only expert prompts, no custom prompts
        : activeNavItem === 'custom'
        ? customPrompts.map(prompt => prompt.title) // Only custom prompts for custom tab
        : getCurrentPrompts(); // Only category-specific preset prompts for other tabs

    return (
        <React.Fragment>
        
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ 
                        duration: 0.15, 
                        ease: "easeInOut" 
                    }}
                >
            {/* Hidden file input for uploads */}
            <style>
                {`
                    @keyframes slideUp {
                        from {
                            transform: translateY(100%) scale(0.95);
                            opacity: 0;
                        }
                        to {
                            transform: translateY(0) scale(1);
                            opacity: 1;
                        }
                    }
                    @keyframes fadeIn {
                        from {
                            opacity: 0;
                        }
                        to {
                            opacity: 1;
                        }
                    }
                `}
            </style>
            
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                accept="image/*,.csv,.txt,.json,.xml,.md"
                multiple
                onChange={handleFileChange}
            />
            
            {/* Navigation Interceptor for Tour Navigation */}
            <NavigationInterceptor 
                messages={messages}
                isActive={isTourMode}
                onNavigationComplete={(destination) => {
                    console.log('🧭 Tour navigated to:', destination);
                }}
            />
            
            {/* Dark overlay when chat is expanded (not on homepage with new tab system) */}
            {!useHomepageState && (
            <ChatOverlay 
                    isVisible={isActuallyChatExpanded} 
                onClick={handleMinimizeChat}
            />
            )}

            {/* Preset Prompts - Above Expanded Chat (not on homepage with new tab system) */}
            {!useHomepageState && isActuallyChatExpanded && messages.length === 0 && !userInput && (
                <PresetPromptsContainer isVisible={true}>
                    <PromptsScrollContainer>
                        {allPrompts.map((prompt, index) => (
                            <PromptBox 
                                key={index}
                                onClick={() => !isLoading && !isTypingState && !isThinking && handlePresetPromptClick(prompt)}
                                style={{ 
                                    opacity: (isLoading || isTypingState || isThinking) ? 0.5 : 1, 
                                    cursor: (isLoading || isTypingState || isThinking) ? 'not-allowed' : 'pointer',
                                    pointerEvents: (isLoading || isTypingState || isThinking) ? 'none' : 'auto'
                                }}
                            >
                                {prompt}
                            </PromptBox>
                        ))}
                    </PromptsScrollContainer>
                </PresetPromptsContainer>
            )}



            {/* OLD CHAT INTERFACE REMOVED - All chat now handled by homepage (landing/index.jsx) */}

            {/* AI Action Feedback */}
            {showActionFeedback && aiActions.length > 0 && (
                <div style={{
                    position: 'fixed',
                    top: '20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: '#1A1A1A',
                    border: '1px solid #FF4500',
                    borderRadius: '8px',
                    padding: '12px 16px',
                    zIndex: 50,
                    maxWidth: '350px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
                }}>
                    <div style={{ 
                        color: '#FF4500', 
                        fontSize: '12px', 
                        fontWeight: '600', 
                        marginBottom: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <div style={{
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#FF4500',
                            animation: 'pulse 1.5s infinite'
                        }}></div>
                        AI Actions Completed
                    </div>
                    {aiActions.map((action, index) => (
                        <div key={index} style={{
                            color: action.success ? '#34C759' : '#FF3B30',
                            fontSize: '11px',
                            marginBottom: '4px',
                            paddingLeft: '14px'
                        }}>
                            {action.success ? '✓' : '✗'} {action.message || action.error}
                        </div>
                    ))}
                    <button 
                        onClick={() => setShowActionFeedback(false)}
                        style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            background: 'transparent',
                            border: 'none',
                            color: '#8E8E93',
                            fontSize: '14px',
                            cursor: 'pointer',
                            width: '20px',
                            height: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        ×
                    </button>
                </div>
            )}



            {/* Category Filter Modal - Only show when NOT on homepage with new tab system */}
            {showCategoryFilter && !isHome && (
                <>
                    <div 
                        onClick={() => setShowCategoryFilter(false)}
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'rgba(0, 0, 0, 0.6)',
                            zIndex: 100,
                            animation: 'fadeIn 0.2s ease'
                        }}
                    />
                    <div style={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        background: '#111111',
                        borderTopLeftRadius: '16px',
                        borderTopRightRadius: '16px',
                        padding: '24px 20px 40px',
                        zIndex: 101,
                        maxWidth: '390px',
                        margin: '0 auto',
                        animation: 'slideUp 0.3s ease',
                        maxHeight: '60vh',
                        overflowY: 'auto'
                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '20px'
                        }}>
                            <h3 style={{
                                color: 'white',
                                fontSize: '16px',
                                fontWeight: '600',
                                margin: 0
                            }}>Filter by Category</h3>
                            <button
                                onClick={() => setShowCategoryFilter(false)}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    color: 'rgba(255, 255, 255, 0.5)',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    padding: 0,
                                    lineHeight: 1
                                }}
                            >×</button>
                        </div>
                        
                        {/* All/Clear Filter Option */}
                        <div
                            onClick={() => {
                                setActiveNavItem(null);
                                setShowCategoryFilter(false);
                            }}
                            style={{
                                padding: '16px',
                                background: !activeNavItem ? '#FF4500' : '#1A1A1A',
                                borderRadius: '12px',
                                marginBottom: '12px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                transition: 'all 0.2s'
                            }}
                        >
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '8px',
                                background: !activeNavItem ? 'rgba(255,255,255,0.2)' : '#2A2A2A',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M3 3H17V17H3V3Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <div>
                                <div style={{ color: 'white', fontSize: '14px', fontWeight: '500' }}>All Categories</div>
                                <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '12px' }}>Show all prompts</div>
                            </div>
                        </div>

                        {/* Category Options */}
                        <div
                            onClick={() => {
                                setActiveNavItem('experts');
                                setShowCategoryFilter(false);
                            }}
                            style={{
                                padding: '16px',
                                background: activeNavItem === 'experts' ? '#FF4500' : '#1A1A1A',
                                borderRadius: '12px',
                                marginBottom: '12px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                transition: 'all 0.2s'
                            }}
                        >
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '8px',
                                background: activeNavItem === 'experts' ? 'rgba(255,255,255,0.2)' : '#2A2A2A',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <ExpertsIcon />
                            </div>
                            <div>
                                <div style={{ color: 'white', fontSize: '14px', fontWeight: '500' }}>Experts</div>
                                <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '12px' }}>Ask industry experts</div>
                            </div>
                        </div>

                        <PermissionWrapper appName="bookings">
                            <div
                                onClick={() => {
                                    setActiveNavItem('bookings');
                                    setShowCategoryFilter(false);
                                }}
                                style={{
                                    padding: '16px',
                                    background: activeNavItem === 'bookings' ? '#FF4500' : '#1A1A1A',
                                    borderRadius: '12px',
                                    marginBottom: '12px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    transition: 'all 0.2s'
                                }}
                            >
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '8px',
                                    background: activeNavItem === 'bookings' ? 'rgba(255,255,255,0.2)' : '#2A2A2A',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white'
                                }}>
                                    <BookingsIcon />
                                </div>
                                <div>
                                    <div style={{ color: 'white', fontSize: '14px', fontWeight: '500' }}>Bookings</div>
                                    <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '12px' }}>Manage events & shows</div>
                                </div>
                            </div>
                        </PermissionWrapper>

                        <PermissionWrapper appName="catalog">
                            <div
                                onClick={() => {
                                    setActiveNavItem('catalog');
                                    setShowCategoryFilter(false);
                                }}
                                style={{
                                    padding: '16px',
                                    background: activeNavItem === 'catalog' ? '#FF4500' : '#1A1A1A',
                                    borderRadius: '12px',
                                    marginBottom: '12px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    transition: 'all 0.2s'
                                }}
                            >
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '8px',
                                    background: activeNavItem === 'catalog' ? 'rgba(255,255,255,0.2)' : '#2A2A2A',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white'
                                }}>
                                    <CatalogIcon />
                                </div>
                                <div>
                                    <div style={{ color: 'white', fontSize: '14px', fontWeight: '500' }}>Catalog</div>
                                    <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '12px' }}>Music & releases</div>
                                </div>
                            </div>
                        </PermissionWrapper>

                        <PermissionWrapper appName="merch">
                            <div
                                onClick={() => {
                                    setActiveNavItem('merch');
                                    setShowCategoryFilter(false);
                                }}
                                style={{
                                    padding: '16px',
                                    background: activeNavItem === 'merch' ? '#FF4500' : '#1A1A1A',
                                    borderRadius: '12px',
                                    marginBottom: '12px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    transition: 'all 0.2s'
                                }}
                            >
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '8px',
                                    background: activeNavItem === 'merch' ? 'rgba(255,255,255,0.2)' : '#2A2A2A',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white'
                                }}>
                                    <MerchIcon />
                                </div>
                                <div>
                                    <div style={{ color: 'white', fontSize: '14px', fontWeight: '500' }}>Merch</div>
                                    <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '12px' }}>Merchandise & products</div>
                                </div>
                            </div>
                        </PermissionWrapper>

                        <PermissionWrapper appName="vault">
                            <div
                                onClick={() => {
                                    setActiveNavItem('custom');
                                    setShowCategoryFilter(false);
                                }}
                                style={{
                                    padding: '16px',
                                    background: activeNavItem === 'custom' ? '#FF4500' : '#1A1A1A',
                                    borderRadius: '12px',
                                    marginBottom: '12px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    transition: 'all 0.2s'
                                }}
                            >
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '8px',
                                    background: activeNavItem === 'custom' ? 'rgba(255,255,255,0.2)' : '#2A2A2A',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white'
                                }}>
                                    <CustomIcon />
                                </div>
                                <div>
                                    <div style={{ color: 'white', fontSize: '14px', fontWeight: '500' }}>Custom</div>
                                    <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '12px' }}>Custom projects</div>
                                </div>
                            </div>
                        </PermissionWrapper>

                        {/* Analytics category temporarily hidden
                        <PermissionWrapper appName="analytics">
                            <div
                                onClick={() => {
                                    setActiveNavItem('analytics');
                                    setShowCategoryFilter(false);
                                }}
                                style={{
                                    padding: '16px',
                                    background: activeNavItem === 'analytics' ? '#FF4500' : '#1A1A1A',
                                    borderRadius: '12px',
                                    marginBottom: '12px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    transition: 'all 0.2s'
                                }}
                            >
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '8px',
                                    background: activeNavItem === 'analytics' ? 'rgba(255,255,255,0.2)' : '#2A2A2A',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white'
                                }}>
                                    <AnalyticsIcon />
                                </div>
                                <div>
                                    <div style={{ color: 'white', fontSize: '14px', fontWeight: '500' }}>Analytics</div>
                                    <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '12px' }}>Data & insights</div>
                                </div>
                            </div>
                        </PermissionWrapper>
                        */}

                        <PermissionWrapper appName="touring">
                            <div
                                onClick={() => {
                                    setActiveNavItem('touring');
                                    setShowCategoryFilter(false);
                                }}
                                style={{
                                    padding: '16px',
                                    background: activeNavItem === 'touring' ? '#FF4500' : '#1A1A1A',
                                    borderRadius: '12px',
                                    marginBottom: '12px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    transition: 'all 0.2s'
                                }}
                            >
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '8px',
                                    background: activeNavItem === 'touring' ? 'rgba(255,255,255,0.2)' : '#2A2A2A',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white'
                                }}>
                                    🚐
                                </div>
                                <div>
                                    <div style={{ color: 'white', fontSize: '14px', fontWeight: '500' }}>Touring</div>
                                    <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '12px' }}>Travel & logistics</div>
                                </div>
                            </div>
                        </PermissionWrapper>

                        <div
                            onClick={() => {
                                navigate('/more/setting/advanced/team-management');
                                setShowCategoryFilter(false);
                            }}
                            style={{
                                padding: '16px',
                                background: '#1A1A1A',
                                borderRadius: '12px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                transition: 'all 0.2s'
                            }}
                        >
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '8px',
                                background: '#2A2A2A',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white'
                            }}>
                                <TeamIcon />
                            </div>
                            <div>
                                <div style={{ color: 'white', fontSize: '14px', fontWeight: '500' }}>Team</div>
                                <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '12px' }}>Manage team members</div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {/* Tour Mode Banner for non-chat pages */}
            {!isHome && isTourMode && (
                <div style={{
                    position: 'fixed',
                    bottom: '20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: 'linear-gradient(135deg, #FF2300 0%, #FF4520 100%)',
                    padding: '12px 20px',
                    borderRadius: '30px',
                    boxShadow: '0 8px 32px rgba(255, 35, 0, 0.4)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    zIndex: 9999,
                    animation: 'slideUpFade 0.3s ease'
                }}>
                    <div style={{ color: '#FFFFFF', fontSize: '14px', fontWeight: '500' }}>
                        Tour Mode Active
                    </div>
                    <button
                        onClick={handleBackToTourChat}
                        style={{
                            background: 'rgba(255, 255, 255, 0.2)',
                            border: '1px solid rgba(255, 255, 255, 0.3)',
                            color: '#FFFFFF',
                            padding: '6px 14px',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
                        }}
                    >
                        Back to Chat
                    </button>
                    <button
                        onClick={handleExitTour}
                        style={{
                            background: 'rgba(0, 0, 0, 0.3)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            color: '#FFFFFF',
                            padding: '6px 14px',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: '500',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'rgba(0, 0, 0, 0.5)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'rgba(0, 0, 0, 0.3)';
                        }}
                    >
                        Exit Tour
                    </button>
                </div>
            )}

            {/* Homepage-specific footer layout */}
            {isHome && hasAIAccess() && (
                <HomepageFooter>
                    

                    {/* Preset Prompts Section / File Previews - Only show when on chat tab and no messages and no setup and not on Daily tab */}
                    {activeTab === 'chat' && messages.length === 0 && !hasSetupToShow && !isTypingState && !typingBuffer && activeNavItem !== 'daily' && (
                    <HomepagePresetsSection>
                        {uploadedImages.length > 0 ? (
                            <div style={{
                                display: 'flex',
                                gap: '8px',
                                padding: '8px 0 8px 0',
                                flexWrap: 'nowrap',
                                overflowX: 'auto',
                                overflowY: 'visible',
                                justifyContent: 'flex-start',
                                alignItems: 'center',
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                                WebkitOverflowScrolling: 'touch'
                            }}
                            >
                                {uploadedImages.map((file, index) => (
                                    <div key={index} style={{
                                        position: 'relative',
                                        width: '50px',
                                        height: '50px',
                                        flexShrink: 0,
                                        margin: index === 0 ? '8px 8px 0 8px' : '8px 8px 0 0'
                                    }}>
                                        <div style={{
                                            width: '100%',
                                            height: '100%',
                                            borderRadius: '12px',
                                            overflow: 'hidden',
                                            border: '1px solid #2A2A2A',
                                            background: '#1A1A1A'
                                        }}>
                                            {file.url ? (
                                                <img 
                                                    src={file.url} 
                                                    alt={file.name}
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover'
                                                    }}
                                                    onError={(e) => e.target.style.display = 'none'}
                                                />
                                            ) : (
                                                <div style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '16px',
                                                    color: '#8E8E93'
                                                }}>
                                                    {file.type === 'text/csv' || file.name.toLowerCase().endsWith('.csv') ? '📊' :
                                                     file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf') ? '📋' :
                                                     file.type?.startsWith('text/') ? '📄' : '📎'}
                                                </div>
                                            )}
                                        </div>
                                        <button
                                            onClick={() => removeImage(index)}
                                            style={{
                                                position: 'absolute',
                                                top: '-8px',
                                                right: '-8px',
                                                width: '16px',
                                                height: '16px',
                                                borderRadius: '50%',
                                                border: '1px solid #000',
                                                background: '#FF4500',
                                                color: 'white',
                                                fontSize: '10px',
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                lineHeight: '1',
                                                boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
                                            }}
                                        >
                                            ×
                                        </button>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <ScrollableContainer className={`${showLeftPrompts ? 'show-left-indicator' : ''} ${showRightPrompts ? 'show-right-indicator' : ''}`}>
                                <ScrollIndicator className="left" onClick={() => scrollLeft(promptsScrollRef)}>
                                    <LeftArrow />
                                </ScrollIndicator>
                                <HomepagePresetsRow 
                                    ref={promptsScrollRef}
                                    onScroll={handlePromptsScroll}
                                >
                                    {allPrompts.map((prompt, index) => (
                                        <HomepagePresetItem 
                                            key={index} 
                                            onClick={() => !isLoading && !isTypingState && !isThinking && handlePresetPromptClick(prompt)}
                                            style={{ 
                                                opacity: (isLoading || isTypingState || isThinking) ? 0.5 : 1, 
                                                cursor: (isLoading || isTypingState || isThinking) ? 'not-allowed' : 'pointer',
                                                pointerEvents: (isLoading || isTypingState || isThinking) ? 'none' : 'auto'
                                            }}
                                        >
                                            {prompt}
                                        </HomepagePresetItem>
                                    ))}
                                </HomepagePresetsRow>
                                <ScrollIndicator className="right" onClick={() => scrollRight(promptsScrollRef)}>
                                    <RightArrow />
                                </ScrollIndicator>
                            </ScrollableContainer>
                        )}
                    </HomepagePresetsSection>
                    )}

                    {/* AI Input Section - Only show when on chat tab and not expanded */}
                    {activeTab === 'chat' && (
                    <HomepageInputSection style={{ padding: '8px 16px' }}>
                            <AnimatePresence mode="wait">
                            {hasSetupToShow ? (
                                <motion.div 
                                    key="setup-button"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.15 }}
                                    style={{ 
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    gap: '8px'
                                }}>
                                    <HomepageInputRow 
                                        onClick={handleShowSetup}
                                        style={{ 
                                            cursor: 'pointer',
                                            background: '#ff2300',
                                            border: '2px solid #ff2300',
                                            borderRadius: '5px',
                                            justifyContent: 'center',
                                            padding: '14px',
                                            transition: 'background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease',
                                            boxShadow: '0 0 40px rgba(255, 35, 0, 0.6), 0 0 80px rgba(255, 35, 0, 0.4)',
                                            width: '100%',
                                            maxWidth: '400px'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.background = '#cc1c00';
                                            e.currentTarget.style.borderColor = '#cc1c00';
                                            e.currentTarget.style.boxShadow = '0 0 50px rgba(255, 35, 0, 0.7), 0 0 100px rgba(255, 35, 0, 0.5)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.background = '#ff2300';
                                            e.currentTarget.style.borderColor = '#ff2300';
                                            e.currentTarget.style.boxShadow = '0 0 40px rgba(255, 35, 0, 0.6), 0 0 80px rgba(255, 35, 0, 0.4)';
                                        }}
                                    >
                                        <div style={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            justifyContent: 'center',
                                            color: '#FFFFFF',
                                            fontSize: '14px',
                                            fontWeight: '500'
                                        }}>
                                            <span>Start your DIZEE setup tour</span>
                                        </div>
                                    </HomepageInputRow>
                                    <div 
                                        onClick={handleDismissSetup}
                                        style={{
                                            cursor: 'pointer',
                                            color: 'rgba(255, 255, 255, 0.6)',
                                            fontSize: '12px',
                                            textDecoration: 'underline',
                                            transition: 'color 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.color = 'rgba(255, 255, 255, 0.9)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.color = 'rgba(255, 255, 255, 0.6)';
                                        }}
                                    >
                                        No thanks
                                    </div>
                                </motion.div>
                            ) : (hasDigestToShow || activeNavItem === 'daily') && messages.length === 0 && !isTypingState && !isThinking ? (
                                <motion.div 
                                    key="digest-button"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.15 }}
                                    style={{ 
                                    display: 'flex',
                                    justifyContent: 'center',
                                    width: '100%'
                                }}>
                                    <HomepageInputRow 
                                        onClick={handleShowDigest}
                                        style={{ 
                                            cursor: 'pointer',
                                            background: '#ff2300',
                                            border: '2px solid #ff2300',
                                            borderRadius: '5px',
                                            justifyContent: 'center',
                                            padding: '14px',
                                            transition: 'background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease',
                                            boxShadow: '0 0 40px rgba(255, 35, 0, 0.6), 0 0 80px rgba(255, 35, 0, 0.4)',
                                            width: '100%',
                                            maxWidth: '400px'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.background = '#cc1c00';
                                            e.currentTarget.style.borderColor = '#cc1c00';
                                            e.currentTarget.style.boxShadow = '0 0 50px rgba(255, 35, 0, 0.7), 0 0 100px rgba(255, 35, 0, 0.5)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.background = '#ff2300';
                                            e.currentTarget.style.borderColor = '#ff2300';
                                            e.currentTarget.style.boxShadow = '0 0 40px rgba(255, 35, 0, 0.6), 0 0 80px rgba(255, 35, 0, 0.4)';
                                        }}
                                    >
                                        <div style={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            justifyContent: 'center',
                                            color: '#FFFFFF',
                                            fontSize: '14px',
                                            fontWeight: '500'
                                        }}>
                                            <span>See Your Daily Digest</span>
                                        </div>
                                    </HomepageInputRow>
                                </motion.div>
                            ) : activeNavItem === 'experts' ? (
                            <motion.div
                                key="experts-input"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.15 }}
                                style={{ width: '100%' }}
                            >
                                <HomepageInputRow>
                                    <ExpertsInputBar>
                                        Select a prompt above
                                    </ExpertsInputBar>
                                </HomepageInputRow>
                            </motion.div>
                            ) : (
                                <motion.div
                                    key="regular-input"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.15 }}
                                    style={{ display: 'contents' }}
                                >
                                    <HomepagePlusBtn onClick={handleFileUpload}>
                                        <Plus1 />
                                    </HomepagePlusBtn>
                                    <HomepageInputRow>
                                        <HomepageInputField
                                            value={userInput}
                                            onChange={(e) => setUserInput(e.target.value)}
                                            onKeyPress={handleKeyPress}
                                            placeholder="Ask me anything..."
                                            disabled={isLoading || isTypingState || isThinking}
                                        />
                                        <HomepageSendBtn 
                                            hasText={userInput.trim().length > 0 || uploadedImages.length > 0}
                                            onClick={handleSendMessage}
                                            disabled={(!userInput.trim() && uploadedImages.length === 0) || isLoading || isTypingState || isThinking}
                                        >
                                            ↗
                                        </HomepageSendBtn>
                                    </HomepageInputRow>
                                </motion.div>
                            )}
                            </AnimatePresence>
                    </HomepageInputSection>
                    )}

                    {/* Categories Navigation OR New Chat Button - Only show when on chat tab */}
                    {activeTab === 'chat' && messages.length === 0 && !hasSetupToShow && !isTypingState && !typingBuffer && (
                        <div style={{ position: 'relative', minHeight: '64px' }}>
                            <AnimatePresence mode="wait">
                            {activeNavItem !== 'daily' && !hasDigestToShow ? (
                                <motion.div
                                    key="categories-nav"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.2 }}
                                >
                                         <ScrollableContainer className={`${showLeftNav ? 'show-left-indicator' : ''} ${showRightNav ? 'show-right-indicator' : ''}`}>
                         <ScrollIndicator className="left" onClick={() => scrollLeft(navScrollRef)}>
                             <LeftArrow />
                         </ScrollIndicator>
                        <HomepageNavigationSection 
                            ref={navScrollRef}
                            onScroll={handleNavScroll}
                        >
                                        {/* Daily category - always visible, shows digest button when selected */}
                                        <HomepageNavItem 
                                            onClick={() => handleCategorySelect('daily')}
                                            style={hasDigestToShow ? { 
                                                background: 'linear-gradient(135deg, #ff2300 0%, #ff6b00 100%)', 
                                                borderRadius: '8px', 
                                                padding: '0 12px' 
                                            } : {}}
                                        >
                                            <HomepageNavText 
                                                active={activeNavItem === 'daily'}
                                                style={hasDigestToShow ? { color: 'white', fontWeight: '600' } : {}}
                                            >
                                                Daily
                                            </HomepageNavText>
                                        </HomepageNavItem>
                                        {/* Order: Daily, Catalog, Bookings, Touring, Experts (Analytics temporarily hidden) */}
                            <PermissionWrapper appName="catalog">
                                            <HomepageNavItem onClick={() => handleCategorySelect('catalog')}>
                                                <HomepageNavText active={activeNavItem === 'catalog'}>Catalog</HomepageNavText>
                                </HomepageNavItem>
                            </PermissionWrapper>
                            <PermissionWrapper appName="bookings">
                                            <HomepageNavItem onClick={() => handleCategorySelect('bookings')}>
                                                <HomepageNavText active={activeNavItem === 'bookings'}>Bookings</HomepageNavText>
                                </HomepageNavItem>
                            </PermissionWrapper>
                            {/* Analytics tab temporarily hidden
                            <PermissionWrapper appName="analytics">
                                            <HomepageNavItem onClick={() => handleCategorySelect('analytics')}>
                                                <HomepageNavText active={activeNavItem === 'analytics'}>Analytics</HomepageNavText>
                                </HomepageNavItem>
                            </PermissionWrapper>
                            */}
                            <PermissionWrapper appName="touring">
                                            <HomepageNavItem onClick={() => handleCategorySelect('touring')}>
                                                <HomepageNavText active={activeNavItem === 'touring'}>Touring</HomepageNavText>
                                </HomepageNavItem>
                            </PermissionWrapper>
                                        <HomepageNavItem onClick={() => handleCategorySelect('experts')}>
                                <HomepageNavText active={activeNavItem === 'experts'}>Experts</HomepageNavText>
                            </HomepageNavItem>
                                                 </HomepageNavigationSection>
                         <ScrollIndicator className="right" onClick={() => scrollRight(navScrollRef)}>
                             <RightArrow />
                         </ScrollIndicator>
                    </ScrollableContainer>
                                </motion.div>
                            ) : (hasDigestToShow || activeNavItem === 'daily') && !isThinking ? (
                                <motion.div
                                    key="digest-new-chat-button"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.2 }}
                                >
                                    <HomepageButtonsContainer style={{ padding: '8px 16px 28px' }}>
                                        <HomepageNewChatButton 
                                            onClick={handleClearAllForNewChat}
                                        >
                                            New Chat
                                        </HomepageNewChatButton>
                                    </HomepageButtonsContainer>
                                </motion.div>
                            ) : null}
                            </AnimatePresence>
                        </div>
                    )}
                            
                            {/* Show Exit Tour + Back to Chat when in tour mode but not on chat page, or Expand/Simplify and New Chat in normal mode */}
                            {activeTab === 'chat' && (
                            <AnimatePresence>
                            {isTourMode ? (
                                <motion.div
                                    key="tour-button"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                >
                                    <HomepageButtonsContainer>
                                        <HomepageNewChatButton 
                                            onClick={handleExitTour}
                                            style={{ 
                                                background: 'rgba(255, 35, 0, 0.1)', 
                                                color: '#FF2300',
                                                borderColor: 'rgba(255, 35, 0, 0.3)'
                                            }}
                                        >
                                            Exit Tour
                                        </HomepageNewChatButton>
                                    </HomepageButtonsContainer>
                                </motion.div>
                            ) : (messages.length > 0 || typingBuffer || isTypingState) && onMaximizeToggle && !hasDigestToShow && (
                                <motion.div
                                    key="chat-buttons"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                >
                                    <HomepageButtonsContainer>
                                        <ExpandSimplifyButton onClick={onMaximizeToggle}>
                                            {isChatMaximized ? 'Simplify' : 'Expand'}
                                        </ExpandSimplifyButton>
                                        <HomepageNewChatButton 
                                            onClick={handleClearAllForNewChat}
                                            disabled={isTypingState || isThinking}
                                        >
                                            New Chat
                                        </HomepageNewChatButton>
                                    </HomepageButtonsContainer>
                                </motion.div>
                            )}
                            </AnimatePresence>
                            )}
                </HomepageFooter>
            )}

            {/* Pages/Unreleased App specific footer layout */}
            {!isChatExpanded && !isHome && (
                <PagesFooter>
                    
                    {/* Preset Prompts Section - Hide when digest is available or Daily tab selected */}
                    {!hasDigestToShow && activeNavItem !== 'daily' && (
                    <PagesPresetsSection>
                                                 <ScrollableContainer className={`${showLeftPagesPrompts ? 'show-left-indicator' : ''} ${showRightPagesPrompts ? 'show-right-indicator' : ''}`}>
                             <ScrollIndicator className="left" onClick={() => scrollLeft(pagesPromptsScrollRef)}>
                                 <LeftArrow />
                             </ScrollIndicator>
                            <PagesPresetsRow 
                                ref={pagesPromptsScrollRef}
                                onScroll={handlePagesPromptsScroll}
                            >
                                {getCurrentPrompts().map((prompt, index) => (
                                    <PagesPresetItem 
                                        key={index} 
                                        onClick={() => !isLoading && !isTypingState && !isThinking && handlePresetPromptClick(prompt)}
                                        style={{
                                            opacity: (isLoading || isTypingState || isThinking) ? 0.5 : 1,
                                            cursor: (isLoading || isTypingState || isThinking) ? 'not-allowed' : 'pointer',
                                            pointerEvents: (isLoading || isTypingState || isThinking) ? 'none' : 'auto'
                                        }}
                                    >
                                        {prompt}
                                    </PagesPresetItem>
                                ))}
                                                         </PagesPresetsRow>
                             <ScrollIndicator className="right" onClick={() => scrollRight(pagesPromptsScrollRef)}>
                                 <RightArrow />
                             </ScrollIndicator>
                        </ScrollableContainer>
                    </PagesPresetsSection>
                    )}

                    {/* AI Input Section - Same as Homepage */}
                    <PagesInputSection style={{ padding: '8px 16px' }}>
                        {(hasDigestToShow || activeNavItem === 'daily') && messages.length === 0 && !isTypingState && !isThinking ? (
                            <div style={{ 
                                display: 'flex',
                                justifyContent: 'center',
                                width: '100%'
                            }}>
                                <PagesInputRow 
                                    onClick={handleShowDigest}
                                    style={{ 
                                        cursor: 'pointer',
                                        background: '#ff2300',
                                        border: '2px solid #ff2300',
                                        borderRadius: '5px',
                                        justifyContent: 'center',
                                        padding: '12px',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 0 40px rgba(255, 35, 0, 0.6), 0 0 80px rgba(255, 35, 0, 0.4)',
                                        width: '100%',
                                        maxWidth: '358px'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.background = '#cc1c00';
                                        e.currentTarget.style.borderColor = '#cc1c00';
                                        e.currentTarget.style.boxShadow = '0 0 50px rgba(255, 35, 0, 0.7), 0 0 100px rgba(255, 35, 0, 0.5)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.background = '#ff2300';
                                        e.currentTarget.style.borderColor = '#ff2300';
                                        e.currentTarget.style.boxShadow = '0 0 40px rgba(255, 35, 0, 0.6), 0 0 80px rgba(255, 35, 0, 0.4)';
                                    }}
                                >
                                    <div style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        justifyContent: 'center',
                                        color: '#FFFFFF',
                                        fontSize: '14px',
                                        fontWeight: '500'
                                    }}>
                                        <span>See Your Daily Digest</span>
                                    </div>
                                </PagesInputRow>
                            </div>
                        ) : (
                            <>
                                <PagesPlusBtn onClick={handleFileUpload}>
                                    <Plus1 />
                                </PagesPlusBtn>
                                <PagesInputRow>
                                    <PagesInputField
                                            value={userInput}
                                            onChange={(e) => setUserInput(e.target.value)}
                                            onKeyPress={handleKeyPress}
                                            placeholder="Ask dizee anything..."
                                        />
                                    <PagesSendBtn 
                                        hasText={userInput.trim().length > 0}
                                            onClick={handleSendMessage}
                                        disabled={!userInput.trim() || isLoading}
                                        >
                                        <Arrow />
                                    </PagesSendBtn>
                                </PagesInputRow>
                            </>
                        )}
                    </PagesInputSection>

                    {/* Show New Chat button when digest button is showing (Pages version) */}
                    <AnimatePresence>
                    {(hasDigestToShow || activeNavItem === 'daily') && messages.length === 0 && !isTypingState && !isThinking && (
                        <motion.div
                            key="pages-digest-new-chat-button"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.15, delay: 0.1 }}
                        >
                            <HomepageButtonsContainer style={{ padding: '8px 16px 28px' }}>
                                <HomepageNewChatButton 
                                    onClick={handleNewChat}
                                >
                                    New Chat
                                </HomepageNewChatButton>
                            </HomepageButtonsContainer>
                        </motion.div>
                    )}
                    </AnimatePresence>

                    {/* Bottom Navigation Section */}
                    <PagesNavigationSection>
                        <PagesNavItem onClick={() => setStyleMenu(true)}>
                            <PagesNavIcon>
                                <RetouchIcon />
                            </PagesNavIcon>
                            <PagesNavText>Retouch</PagesNavText>
                        </PagesNavItem>
                        
                        <PagesCenterPlusBtn onClick={() => navigate("/add-section")}>
                        </PagesCenterPlusBtn>
                        
                        <PagesNavItem onClick={() => setColor(true)}>
                            <PagesNavIcon>
                                <ColorIcon />
                            </PagesNavIcon>
                            <PagesNavText>Color</PagesNavText>
                        </PagesNavItem>
                    </PagesNavigationSection>
                </PagesFooter>
            )}

            {/* Style Menu (Retouch options) */}
            {styleMenu && !isHome && (
                <PagesFooter>
                    <PagesNavigationSection>
                        <PagesNavItem onClick={() => {
                            setGrayScaleBar(true);
                            setStyleMenu(false);
                        }}>
                            <PagesNavText>Grayscale</PagesNavText>
                        </PagesNavItem>
                        
                        <PagesNavItem onClick={() => {
                            setNoiseBar(true);
                            setStyleMenu(false);
                        }}>
                            <PagesNavText>Noise</PagesNavText>
                        </PagesNavItem>
                        
                        <PagesNavItem onClick={() => setStyleMenu(false)}>
                            <PagesNavText>Back</PagesNavText>
                        </PagesNavItem>
                    </PagesNavigationSection>
                </PagesFooter>
            )}

            {/* Grayscale Bar */}
            {grayScaleBar && !isHome && (
                <PagesFooter>
                    <PagesNavigationSection style={{ justifyContent: 'space-around' }}>
                        <PagesNavText>Grayscale</PagesNavText>
                        
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <span style={{ color: 'white', fontSize: '11px', minWidth: '25px' }}>
                                {userArticle?.grayscale || 0}%
                            </span>
                            <GrayscaleSlider
                                type="range"
                                min="0"
                                max="100"
                                value={userArticle?.grayscale ?? 0}
                                onChange={onChangeGrayScale}
                            />
                        </div>
                        
                        <PagesNavItem onClick={() => { 
                            updateUserArticle(false); 
                            setGrayScaleBar(false); 
                        }}>
                            <PagesNavText>Confirm</PagesNavText>
                        </PagesNavItem>
                        
                        <PagesNavItem onClick={() => setGrayScaleBar(false)}>
                            <PagesNavText>Back</PagesNavText>
                        </PagesNavItem>
                    </PagesNavigationSection>
                </PagesFooter>
            )}

            {/* Noise Bar */}
            {noiseBar && !isHome && (
                <PagesFooter>
                    <PagesNavigationSection style={{ justifyContent: 'space-around' }}>
                        <PagesNavText>Noise</PagesNavText>
                        
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <span style={{ color: 'white', fontSize: '11px', minWidth: '25px' }}>
                                {userArticle?.noise || 0}%
                            </span>
                            <GrayscaleSlider
                                type="range"
                                min="0"
                                max="100"
                                value={userArticle?.noise ?? 0}
                                onChange={onChangeNoise}
                            />
                        </div>
                        
                        <PagesNavItem onClick={() => { 
                            updateUserArticle(false); 
                            setNoiseBar(false); 
                        }}>
                            <PagesNavText>Confirm</PagesNavText>
                        </PagesNavItem>
                        
                        <PagesNavItem onClick={() => {
                            setNoiseBar(false);
                            resetEffects();
                        }}>
                            <PagesNavText>Back</PagesNavText>
                        </PagesNavItem>
                    </PagesNavigationSection>
                </PagesFooter>
            )}

            {/* Color Menu */}
            {color && !isHome && (
                <PagesFooter>
                    <PagesNavigationSection>
                        <PagesNavItem onClick={() => {
                            setBackgroundColor(true);
                            setColor(false);
                        }}>
                            <PagesNavText>Background</PagesNavText>
                        </PagesNavItem>
                        
                        <PagesNavItem onClick={() => {
                            setAccentColor(true);
                            setColor(false);
                        }}>
                            <PagesNavText>Accent</PagesNavText>
                        </PagesNavItem>
                        
                        <PagesNavItem onClick={() => setColor(false)}>
                            <PagesNavText>Back</PagesNavText>
                        </PagesNavItem>
                    </PagesNavigationSection>
                </PagesFooter>
            )}

            {/* Background Color */}
            {backgroundColor && !isHome && (
                <PagesFooter>
                    <PagesNavigationSection style={{ justifyContent: 'space-around', gap: '5px' }}>
                        <PagesNavItem onClick={() => setBackgroundShade(true)}>
                            <PagesNavText>Shade</PagesNavText>
                        </PagesNavItem>
                        
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <input
                                type="text"
                                value={(hexBackground || "#000000").toUpperCase()}
                                onChange={handleColorInput}
                                style={{
                                    background: 'transparent',
                                    width: '50px',
                                    textAlign: 'center',
                                    outline: 'none',
                                    border: 'none',
                                    color: 'white',
                                    fontSize: '9px'
                                }}
                            />
                            <ColorSlider
                                type="range"
                                min="0"
                                max="360"
                                value={hue}
                                onChange={handleHueChangeBackground}
                                style={{
                                    background: `linear-gradient(to right, 
                                        hsl(0, 100%, 50%), 
                                        hsl(60, 100%, 50%), 
                                        hsl(120, 100%, 50%), 
                                        hsl(180, 100%, 50%), 
                                        hsl(240, 100%, 50%), 
                                        hsl(300, 100%, 50%), 
                                        hsl(360, 100%, 50%))`
                                }}
                            />
                        </div>
                        
                        <PagesNavItem onClick={() => {
                            updateUserArticle(false);
                            setBackgroundColor(false);
                            setBackgroundShade(false);
                            setAccentColor(false);
                            setAccentShade(false);
                        }}>
                            <PagesNavText>Confirm</PagesNavText>
                        </PagesNavItem>
                        
                        <PagesNavItem onClick={() => {
                            setBackgroundColor(false);
                            setBackgroundShade(false);
                            setAccentColor(false);
                            setAccentShade(false);
                        }}>
                            <PagesNavText>Back</PagesNavText>
                        </PagesNavItem>
                    </PagesNavigationSection>
                </PagesFooter>
            )}

            {/* Background Shade */}
            {backgroundShade && !isHome && (
                <PagesFooter>
                    <PagesNavigationSection style={{ justifyContent: 'space-around' }}>
                        <PagesNavItem onClick={() => {
                            setBackgroundShade(false);
                            setBackgroundColor(true);
                        }}>
                            <PagesNavText>Color</PagesNavText>
                        </PagesNavItem>
                        
                        <BrightnessSlider
                            type="range"
                            min="0"
                            max="100"
                            value={brightness}
                            onChange={handleBrightnessChangeBackground}
                            style={{
                                background: `linear-gradient(to right, black, hsl(${hue}, 100%, 50%), white)`
                            }}
                        />
                        
                        <PagesNavItem onClick={() => updateUserArticle(false)}>
                            <PagesNavText>Confirm</PagesNavText>
                        </PagesNavItem>
                        
                        <PagesNavItem onClick={() => {
                            setBackgroundColor(false);
                            setBackgroundShade(false);
                            setAccentColor(false);
                            setAccentShade(false);
                        }}>
                            <PagesNavText>Back</PagesNavText>
                        </PagesNavItem>
                    </PagesNavigationSection>
                </PagesFooter>
            )}

            {/* Accent Color */}
            {accentColor && !isHome && (
                <PagesFooter>
                    <PagesNavigationSection style={{ justifyContent: 'space-around', gap: '5px' }}>
                        <PagesNavItem onClick={() => setAccentShade(true)}>
                            <PagesNavText>Shade</PagesNavText>
                        </PagesNavItem>
                        
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <input
                                type="text"
                                value={(hexAccent || "#000000").toUpperCase()}
                                onChange={handleAccentColorInput}
                                style={{
                                    background: 'transparent',
                                    width: '50px',
                                    textAlign: 'center',
                                    outline: 'none',
                                    border: 'none',
                                    color: 'white',
                                    fontSize: '9px'
                                }}
                            />
                            <ColorSlider
                                type="range"
                                min="0"
                                max="360"
                                value={hue}
                                onChange={handleHueChangeAccent}
                                style={{
                                    background: `linear-gradient(to right, 
                                        hsl(0, 100%, 50%), 
                                        hsl(60, 100%, 50%), 
                                        hsl(120, 100%, 50%), 
                                        hsl(180, 100%, 50%), 
                                        hsl(240, 100%, 50%), 
                                        hsl(300, 100%, 50%), 
                                        hsl(360, 100%, 50%))`
                                }}
                            />
                        </div>
                        
                        <PagesNavItem onClick={() => {
                            updateUserArticle(false);
                            setBackgroundColor(false);
                            setBackgroundShade(false);
                            setAccentColor(false);
                            setAccentShade(false);
                        }}>
                            <PagesNavText>Confirm</PagesNavText>
                        </PagesNavItem>
                        
                        <PagesNavItem onClick={() => {
                            setBackgroundColor(false);
                            setBackgroundShade(false);
                            setAccentColor(false);
                            setAccentShade(false);
                        }}>
                            <PagesNavText>Back</PagesNavText>
                        </PagesNavItem>
                    </PagesNavigationSection>
                </PagesFooter>
            )}

            {/* Accent Shade */}
            {accentShade && !isHome && (
                <PagesFooter>
                    <PagesNavigationSection style={{ justifyContent: 'space-around' }}>
                        <PagesNavItem onClick={() => {
                            setAccentShade(false);
                            setAccentColor(true);
                        }}>
                            <PagesNavText>Color</PagesNavText>
                        </PagesNavItem>
                        
                        <BrightnessSlider
                            type="range"
                            min="0"
                            max="100"
                            value={brightness}
                            onChange={handleBrightnessChangeAccent}
                            style={{
                                background: `linear-gradient(to right, black, hsl(${hue}, 100%, 50%), white)`
                            }}
                        />
                        
                        <PagesNavItem onClick={() => updateUserArticle(false)}>
                            <PagesNavText>Confirm</PagesNavText>
                        </PagesNavItem>
                        
                        <PagesNavItem onClick={() => {
                            setBackgroundColor(false);
                            setBackgroundShade(false);
                            setAccentColor(false);
                            setAccentShade(false);
                        }}>
                            <PagesNavText>Back</PagesNavText>
                        </PagesNavItem>
                    </PagesNavigationSection>
                </PagesFooter>
            )}


                </motion.div>
            )}
        </AnimatePresence>
        
        <ConfirmModal
            isOpen={confirmState.isOpen}
            onClose={confirmHandleClose}
            onConfirm={confirmHandleConfirm}
            title={confirmState.title}
            message={confirmState.message}
            confirmLabel={confirmState.confirmLabel}
            cancelLabel={confirmState.cancelLabel}
            confirmStyle={confirmState.confirmStyle}
        />
        </React.Fragment>
    );
};

export default FooterBar;